/* Deutsch — German */
const de = {
  nav: {
    home: 'Startseite',
    imageConverter: 'Bildkonverter',
    imageCompressor: 'Bildkompressor',
    otherTools: 'Weitere Tools',
    resizeImage: 'Bild skalieren',
    cropImage: 'Bild zuschneiden',
    photoEditor: 'Fotoeditor',
    removeBackground: 'Hintergrund entfernen',
    watermarkImage: 'Wasserzeichen',
    qrCodeGenerator: 'QR-Code-Generator',
    qrCodeScanner: 'QR-Code-Scanner',
    aboutUs: 'Über Uns',
    faceBlur: 'Gesicht unscharf',
  },
  hero: {
    heading: 'Alle Bildtools, die Sie brauchen',
    subheading: 'Kostenlose Online-Tools zum Konvertieren, Komprimieren, Skalieren, Zuschneiden, Bearbeiten und Transformieren Ihrer Bilder. Die gesamte Verarbeitung erfolgt in Ihrem Browser — schnell, privat und sicher.',
  },
  tools: {
    compressImage: { title: 'Bild KOMPRIMIEREN', desc: 'Komprimieren Sie JPG, PNG, SVG und GIF und sparen Sie Speicherplatz bei gleichbleibender Qualität.' },
    resizeImage: { title: 'Bild SKALIEREN', desc: 'Definieren Sie Ihre Abmessungen in Prozent oder Pixel und skalieren Sie Ihre Bilder.' },
    cropImage: { title: 'Bild ZUSCHNEIDEN', desc: 'Schneiden Sie JPG, PNG oder GIF einfach zu.' },
    convertToJpg: { title: 'In JPG konvertieren', desc: 'Konvertieren Sie PNG, GIF, SVG, WEBP-Bilder stapelweise in JPG.' },
    convertFromJpg: { title: 'Von JPG konvertieren', desc: 'Konvertieren Sie JPG-Bilder in PNG und GIF.' },
    qrCodeGenerator: { title: 'QR-Code-Generator', desc: 'Erstellen Sie benutzerdefinierte QR-Codes für URLs, Text, WiFi und Kontakte.' },
    qrCodeScanner: { title: 'QR-Code-Scanner', desc: 'Scannen Sie QR-Codes sofort mit Ihrer Kamera oder durch Hochladen eines Bildes.' },
    blurFace: { title: 'Gesicht unscharf machen', desc: 'Erkennen und unscharf machen von Gesichtern in Ihren Bildern automatisch.' },
    removeBackground: { title: 'Hintergrund entfernen', desc: 'Entfernen Sie Bildhintergründe schnell und präzise.' },
    watermarkImage: { title: 'Wasserzeichen BILD', desc: 'Fügen Sie in Sekunden ein Bild oder Text auf Ihre Bilder ein.' },
  },
  whyChoose: {
    label: 'Warum Uns Wählen',
    heading: 'Der intelligentere Weg, Bilder zu bearbeiten',
    subheading: 'Tausende von Kreativen, Designern und Entwicklern weltweit vertrauen uns.',
    reasons: {
      fast: { title: 'Blitzschnell', desc: 'Die gesamte Verarbeitung erfolgt direkt in Ihrem Browser. Kein Upload auf externe Server.' },
      private: { title: '100% Privat & Sicher', desc: 'Ihre Dateien verlassen niemals Ihr Gerät.' },
      noLimits: { title: 'Keine Grenzen, Keine Anmeldung', desc: 'Nutzen Sie jedes Tool so oft wie Sie möchten — völlig kostenlos.' },
      quality: { title: 'Professionelle Qualität', desc: 'Unsere Algorithmen liefern Ergebnisse in Studioqualität.' },
      batch: { title: 'Stapelverarbeitung', desc: 'Bearbeiten Sie mehrere Dateien gleichzeitig.' },
      everywhere: { title: 'Funktioniert Überall', desc: 'Vollständig responsives Design für Desktop, Tablet und Mobilgeräte.' },
    },
    stats: {
      imagesProcessed: 'Bilder verarbeitet',
      countriesServed: 'Bediente Länder',
      uptime: 'Verfügbarkeit',
      freeTools: 'Kostenlose Tools',
    },
  },
  footer: {
    tagline: 'Kostenlose Online-Bildtools — konvertieren, komprimieren, skalieren, zuschneiden und bearbeiten Sie Ihre Bilder in Sekunden. Keine Anmeldung erforderlich.',
    imageTools: 'Bildtools',
    moreTools: 'Weitere Tools',
    company: 'Unternehmen',
    contact: 'Kontakt',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
  },
  faq: {
    badge: 'FAQ',
    heading: 'Häufig Gestellte Fragen',
    subheading: 'Schnelle Antworten auf häufige Fragen zu diesem Tool.',
    stillHaveQuestions: 'Noch Fragen? Wir helfen Ihnen gerne!',
    reachOut: 'Kontaktieren Sie Unser Team',
    questionHeader: 'Frage',
  },

  contactForm: {
    badge: 'Kontakt aufnehmen',
    title: 'Kontaktiere uns',
    subtitle: 'Wir freuen uns von Ihnen zu hören. Schicken Sie uns eine Nachricht!',
    nameLabel: 'Name',
    namePlaceholder: 'Ihr vollständiger Name',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'sie@email.de',
    subjectLabel: 'Betreff',
    subjectPlaceholder: 'Worum geht es?',
    messageLabel: 'Nachricht',
    messagePlaceholder: 'Schreiben Sie hier Ihre Nachricht…',
    errName: 'Name ist erforderlich',
    errEmail: 'E-Mail ist erforderlich',
    errEmailInvalid: 'Geben Sie eine gültige E-Mail ein',
    errSubject: 'Betreff ist erforderlich',
    errMessage: 'Nachricht ist erforderlich',
    sending: 'Wird gesendet…',
    send: 'Nachricht Senden',
    successTitle: 'Nachricht Gesendet!',
    successMsg: 'Danke für Ihre Nachricht. Wir melden uns bald.',
    sendAnother: 'Weitere Nachricht senden',
    sendError: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  },

  about: {
    label: 'Über Uns',
    heading: 'Für Kreative, von Kreativen',
    subheading: 'Wir glauben, dass leistungsstarke Bildtools kostenlos, schnell und für alle zugänglich sein sollten.',
    missionTitle: 'Unsere Mission',
    missionText: 'photremium.com wurde mit einem einfachen Ziel erstellt: die intuitivste, schnellste und privateste Bildbearbeitungserfahrung im Web zu bieten.',
    privacyTitle: 'Datenschutz zuerst',
    privacyText: 'Wir laden, speichern oder verarbeiten Ihre Bilder niemals auf Remote-Servern.',
    techTitle: 'Moderne Technologie',
    techText: 'Gebaut mit modernsten Webtechnologien einschließlich WebAssembly, Canvas API und modernem React.',
    communityTitle: 'Community-gesteuert',
    communityText: 'Jede Funktion, die wir entwickeln, ist von echtem Nutzerfeedback inspiriert.',
    globalTitle: 'Globale Reichweite',
    globalText: 'Von Kreativen in über 120 Ländern genutzt.',
  },
  seo: {
    homeTitle: 'photremium.com — Kostenloser Online-Bildkonverter, Kompressor & Editor',
    homeDesc: 'Bilder online kostenlos konvertieren, komprimieren, skalieren, zuschneiden und bearbeiten.',
    homeKeywords: 'Bildkonverter, Bildkompressor, Bild skalieren, Fotoeditor',
    aboutTitle: 'Über photremium.com — Unsere Mission & Geschichte',
    aboutDesc: 'Erfahren Sie mehr über photremium.com, das kostenlose Online-Bildtoolkit.',
    aboutKeywords: 'über photremium.com, Bildtools, kostenloser Bildeditor',
  },

  privacyPolicyPage: {
    seo: {
      title: 'Datenschutzerklärung — Photremium | Keine Server-Uploads, keine Datenspeicherung',
      description: 'Die Datenschutzerklärung von Photremium erklärt, wie wir Ihre Privatsphäre schützen. Alle Verarbeitung erfolgt im Browser.',
      ogTitle: 'Datenschutzerklärung — Photremium | Keine Uploads, kein Speicher',
      ogDescription: 'Ihre Dateien bleiben auf Ihrem Gerät. Die Verarbeitung erfolgt lokal im Browser.',
      twitterTitle: 'Datenschutzerklärung — Photremium',
      twitterDescription: '100% Browser-Tools. Keine Uploads, kein Speicher, kein Tracking.',
      schemaName: 'Datenschutzerklärung - Photremium',
      schemaDescription: 'Photremium Datenschutzerklärung: keine Server-Uploads, keine Datenspeicherung.',
    },
    hero: {
      badge: 'Datenschutzerklärung',
      titlePrefix: 'Ihre Privatsphäre hat bei uns',
      titleHighlight: 'oberste Priorität',
      subPrefix: 'photremium.com basiert auf einem einfachen Prinzip —',
      subStrong: 'Ihre Dateien verlassen niemals Ihr Gerät',
      subSuffix: 'Alle Tools laufen vollständig im Browser. Kein Upload. Keine Cloud. Kein Kompromiss.',
      effectiveLabel: 'Gültig ab',
      lastUpdatedLabel: 'Zuletzt aktualisiert',
      worldwideLabel: 'Weltweit gültig',
    },
    trustCards: [
      { title: 'Keine Server-Uploads', desc: 'Ihre Dateien verlassen Ihr Gerät nicht. Verarbeitung komplett lokal.' },
      { title: 'Null Datenspeicherung', desc: 'Wir speichern nichts über Sie, Ihre Bilder oder Aktivität.' },
      { title: 'Kein Tracking', desc: 'Kein Verhaltens-Tracking, kein Fingerprinting, kein Profiling.' },
      { title: 'DSGVO-freundlich', desc: 'Von Grund auf für globale Datenschutzvorgaben entwickelt.' },
    ],
    contentsTitle: 'Inhalt',
    toc: {
      overview: 'Überblick',
      'no-upload': 'Keine Serververarbeitung',
      'data-collect': 'Welche Daten wir erfassen',
      cookies: 'Cookies & Speicher',
      'third-party': 'Drittanbieter-Dienste',
      analytics: 'Analytik',
      children: 'Datenschutz für Kinder',
      rights: 'Ihre Rechte',
      security: 'Sicherheit',
      changes: 'Richtlinienänderungen',
      contact: 'Kontakt',
    },
    sections: {
      overview: {
        title: '1. Überblick',
        subtitle: 'Was diese Richtlinie abdeckt',
        p1Prefix: 'Diese Datenschutzerklärung beschreibt, wie',
        p1Middle: '("wir", "uns", "unser") mit Ihren personenbezogenen Daten umgeht - oder genauer gesagt,',
        p1Italic: 'nicht umgeht',
        p1Suffix: 'wenn Sie unsere kostenlosen Online-Bildtools auf',
        p2: 'Im Gegensatz zu klassischen Webanwendungen, die Dateien an entfernte Server senden, nutzt photremium.com moderne Browser-APIs (Canvas API, WebAssembly, WebWorkers), um alle Vorgänge lokal auf Ihrem Gerät auszuführen. Ergebnis: keine Datenübertragung, keine Speicherung, kein Risiko.',
        calloutLabel: 'Kurz gesagt:',
        calloutText: 'Wir können Ihre Bilder nicht sehen, wir wollen es nicht, und unsere Technologie ist so gebaut, dass es auch nie möglich ist.',
      },
      noUpload: {
        title: '2. Keine Serververarbeitung — niemals',
        subtitle: 'Wie unsere Tools tatsächlich funktionieren',
        introPrefix: 'Jedes Tool auf photremium.com — Konverter, Kompressor, Resize, Hintergrund entfernen, Face Blur, Wasserzeichen, Zuschneiden und QR — verarbeitet Ihre Dateien',
        introStrong: '100% in Ihrem Webbrowser',
        introSuffix: 'mit clientseitigem JavaScript und WebAssembly.',
        points: [
          { label: 'Kein Datei-Upload.', text: 'Bei Auswahl einer Datei wird sie per File API im Browser gelesen und im Speicher verarbeitet; sie wird nicht über das Netzwerk gesendet.' },
          { label: 'Kein Server erhält Ihr Bild.', text: 'Unser CDN liefert nur HTML, CSS und JavaScript aus, nicht Ihre Dateien.' },
          { label: 'Keine temporäre Speicherung.', text: 'Ergebnisse existieren nur im Browser-Speicher und werden beim Verlassen freigegeben.' },
          { label: 'Funktioniert offline.', text: 'Viele Tools funktionieren nach dem ersten Laden auch ohne Internet.' },
        ],
        callout: 'Sie können das selbst prüfen: Öffnen Sie den Netzwerk-Tab in den DevTools, wählen Sie ein Bild und bestätigen Sie, dass keine Dateidaten an externe Server übertragen werden.',
      },
      dataCollect: {
        title: '3. Daten, die wir erfassen (und nicht erfassen)',
        subtitle: 'Volle Transparenz zu Datenpraktiken',
        headers: { type: 'Datentyp', collected: 'Erfasst?', whereWhy: 'Wo / warum' },
        rows: [
          { type: 'Ihre Bilder / Dateien', badge: 'Nie', variant: 'green', showX: true, whereWhy: 'Komplett im Browser verarbeitet — nie übertragen' },
          { type: 'Name / E-Mail-Adresse', badge: 'Nie', variant: 'green', showX: true, whereWhy: 'Kein Konto oder Sign-up erforderlich' },
          { type: 'IP-Adresse', badge: 'Minimal', variant: 'gray', showX: false, whereWhy: 'Standard-Logs <= 30 Tage, nicht identitätsgebunden' },
          { type: 'Browser / Betriebssystem', badge: 'Minimal', variant: 'gray', showX: false, whereWhy: 'Automatisch vom Browser gesendet; nur Kompatibilität' },
          { type: 'Besuchte Seiten / Klicks', badge: 'Aggregiert', variant: 'blue', showX: false, whereWhy: 'Nur anonyme Analytik' },
          { type: 'Sprachpräferenz', badge: 'Nur lokal', variant: 'blue', showX: false, whereWhy: 'In localStorage auf Ihrem Gerät gespeichert' },
          { type: 'Zahlungsdaten', badge: 'Nie', variant: 'green', showX: true, whereWhy: 'photremium.com ist vollständig kostenlos' },
        ],
      },
      cookies: {
        title: '4. Cookies & lokaler Speicher',
        subtitle: 'Was auf Ihrem Gerät gespeichert wird',
        intro: 'photremium.com verwendet keine Werbe-Cookies, kein Cross-Site-Tracking und keine Drittanbieter-Cookies.',
        points: [
          { label: 'Sprachpräferenz', text: 'Wird in localStorage gespeichert, damit Ihre Sprache erhalten bleibt.' },
          { label: 'Theme / UI-Präferenzen', text: 'Anzeigepräferenzen werden nur lokal auf Ihrem Gerät gespeichert.' },
          { label: 'Keine Session-Cookies.', text: 'Kein Login-System, daher keine Session-ID-Cookies.' },
        ],
        callout: 'Sie können den lokalen Speicher von photremium.com jederzeit in Ihren Browsereinstellungen löschen.',
      },
      thirdParty: {
        title: '5. Drittanbieter-Dienste',
        subtitle: 'Welche externen Dienste wir nutzen und warum',
        intro: 'photremium.com nutzt ein minimales Set vertrauenswürdiger Drittanbieter nur für Infrastruktur und Performance.',
        headers: { service: 'Dienst', purpose: 'Zweck', dataShared: 'Geteilte Daten', privacyPolicy: 'Datenschutzerklärung' },
        rows: [
          { service: 'Cloudflare Pages', purpose: 'Hosting & CDN-Auslieferung', dataShared: 'IP-Adresse, HTTP-Header (Standard)', privacyLink: 'https://www.cloudflare.com/privacypolicy/', privacyText: 'cloudflare.com/privacypolicy' },
          { service: 'Font Awesome', purpose: 'Icon-Fonts über CDN', dataShared: 'IP-Adresse (nur CSS-Anfrage)', privacyLink: 'https://fontawesome.com/privacy', privacyText: 'fontawesome.com/privacy' },
          { service: 'Google Fonts', purpose: 'Schriftarten-Laden', dataShared: 'IP-Adresse (nur Font-Anfrage)', privacyLink: 'https://policies.google.com/privacy', privacyText: 'policies.google.com' },
        ],
        outro: 'Wir teilen Ihre Daten nicht mit Werbetreibenden, Datenhändlern oder anderen Dritten.',
      },
      analytics: {
        title: '6. Analytik',
        subtitle: 'Aggregierte, datenschutzfreundliche Nutzungsdaten',
        introPrefix: 'Um zu verstehen, welche Tools beliebt sind, können wir',
        introStrong: 'aggregierte und anonymisierte',
        introSuffix: 'Nutzungsstatistiken erfassen, z. B.:',
        points: [
          'Anzahl der Seitenaufrufe pro Tool (ohne Benutzeridentifikation)',
          'Quelle des Besuchs (z. B. Google-Suche, Direktlink) — ohne personenbezogene Daten',
          'Geodaten auf Länderebene',
          'Browser- / Gerätetyp für Kompatibilität',
        ],
        calloutLabel: 'Keine Daten sind persönlich mit Ihnen verknüpft.',
        calloutText: 'Wir verwenden weder Google Analytics noch Meta Pixel.',
      },
      children: {
        title: '7. Datenschutz für Kinder',
        subtitle: 'Einhaltung von Kinderschutzrichtlinien',
        p1: 'photremium.com sammelt wissentlich keine personenbezogenen Daten von Kindern unter 13 Jahren (oder 16 in der EU gemäß DSGVO).',
        p2Prefix: 'Wenn Sie glauben, dass ein Kind Daten über unser Kontaktformular gesendet hat, kontaktieren Sie uns bitte sofort unter',
        p2Suffix: 'und wir löschen diese umgehend.',
      },
      rights: {
        title: '8. Ihre Rechte',
        subtitle: 'Globale Datenschutzrechte',
        intro: 'Da photremium.com keine personenbezogenen Daten sammelt, gelten viele Betroffenenrechte trivial.',
        points: [
          { label: 'Recht auf Auskunft', text: 'Sie können eine Kopie der über Sie gespeicherten Daten anfordern.' },
          { label: 'Recht auf Berichtigung', text: 'Sie können die Korrektur unrichtiger Daten verlangen.' },
          { label: 'Recht auf Löschung', text: 'Sie können die Löschung personenbezogener Daten anfordern (DSGVO Art. 17, CCPA).' },
          { label: 'Widerspruch / Opt-out', text: 'Sie können zukünftige Analytik per Browser-Opt-out deaktivieren.' },
          { label: 'Datenübertragbarkeit', text: 'Ihre Arbeit wird direkt auf Ihr Gerät heruntergeladen.' },
        ],
        callout: 'Diese Rechte gelten weltweit für alle Nutzer.',
      },
      security: {
        title: '9. Sicherheit',
        subtitle: 'Wie wir Ihre Erfahrung schützen',
        intro: 'Die sichersten Daten sind die, die nie erhoben werden.',
        points: [
          { label: 'HTTPS-Erzwingung', text: 'Verkehr zwischen Browser und CDN ist per TLS 1.2+ und HSTS verschlüsselt.' },
          { label: 'Content Security Policy (CSP)', text: 'Strikte Header verhindern XSS und Script-Injektionen.' },
          { label: 'Regelmäßige Abhängigkeits-Audits', text: 'Wir auditieren und aktualisieren npm-Pakete regelmäßig.' },
        ],
        disclosurePrefix: 'Verantwortungsvolle Offenlegung',
        disclosureTextPrefix: 'Wenn Sie ein Sicherheitsproblem finden, schreiben Sie an',
        disclosureTextSuffix: 'und wir antworten innerhalb von 48 Stunden.',
      },
      changes: {
        title: '10. Änderungen dieser Richtlinie',
        subtitle: 'Wie wir Aktualisierungen handhaben',
        intro: 'Wir können diese Richtlinie von Zeit zu Zeit aktualisieren.',
        points: [
          { label: '"Zuletzt aktualisiert"', text: 'Das Datum oben auf dieser Seite wird angepasst.' },
          { label: 'Wesentliche Änderungen', text: 'werden mindestens 30 Tage lang über einen Hinweis auf der Startseite kommuniziert.' },
          { label: 'Frühere Versionen', text: 'werden archiviert und auf Anfrage bereitgestellt.' },
        ],
        outro: 'Die fortgesetzte Nutzung von photremium.com nach Veröffentlichung gilt als Zustimmung zur aktualisierten Richtlinie.',
      },
      contact: {
        title: '11. Kontakt & Datenanfragen',
        subtitle: 'Kontaktieren Sie uns zum Datenschutz',
        p1Prefix: 'Bei Fragen, Anliegen oder formellen Datenanfragen zu dieser Richtlinie kontaktieren Sie uns bitte. Wir antworten innerhalb von',
        p1Strong: '5 Werktagen',
      },
    },
    footer: {
      privacyQuestionsTitle: 'Fragen zum Datenschutz?',
      privacyQuestionsDesc: 'Senden Sie uns Ihre Fragen oder Datenanfragen, wir antworten zeitnah.',
      versionHistoryTitle: 'Versionsverlauf',
      v2Label: 'v2.0 — Große Überarbeitung',
      v11Label: 'v1.1 — CCPA-Rechte hinzugefügt',
      v10Label: 'v1.0 — Erste Richtlinie',
    },
  },

  common: {
    new: 'Neu!',
    download: 'Herunterladen',
    downloadAll: 'Alle herunterladen',
    upload: 'Hochladen',
    dragDrop: 'Bilder hierher ziehen oder zum Durchsuchen klicken',
    remove: 'Entfernen',
    reset: 'Zurücksetzen',
    apply: 'Anwenden',
    cancel: 'Abbrechen',
    clear: 'Löschen',
    close: 'Schließen',
    save: 'Speichern',
    processing: 'Verarbeitung...',
    noFiles: 'Keine Dateien ausgewählt',
    selectFiles: 'Dateien auswählen',
    or: 'oder',
    browseFiles: 'Dateien durchsuchen',
    dropHere: 'Dateien hier ablegen',
    quality: 'Qualität',
    width: 'Breite',
    height: 'Höhe',
    format: 'Format',
    compression: 'Kompression',
    preview: 'Vorschau',
    original: 'Original',
    result: 'Ergebnis',
    before: 'Vorher',
    after: 'Nachher',
    downloadAs: 'Herunterladen als:',
    zip: 'ZIP',
    separate: 'Einzeln',
    chooseFiles: 'Dateien auswählen',
    pasteHint: 'Sie können Bilder auch einfügen mit',
    startOver: 'Neu starten',
    startOverConfirm: 'Möchten Sie wirklich alle Bilder entfernen und neu beginnen?',
    addMoreImages: 'Weitere Bilder hinzufügen',
    addImage: 'Bild hinzufügen',
    images: 'Bilder',
    totalSize: 'Gesamtgröße',
    size: 'Größe',
    type: 'Typ',
    unsavedEdits: 'Sie haben ungespeicherte Bearbeitungen. Seite verlassen?',
    compareSlider: 'Vergleichsregler',
    toggleToolsPanel: 'Werkzeugbereich umschalten',
    closePanel: 'Bereich schließen',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    fit: 'Anpassen',
    none: 'Keine',
  },

  compressor: {
    seo: {
      uploadTitle: 'Bildkompressor — JPG, PNG, SVG, GIF kostenlos komprimieren | photremium.com',
      uploadDesc: 'Komprimieren Sie JPG-, PNG-, SVG- und GIF-Bilder online kostenlos. Bis zu 80% kleinere Dateien.',
      uploadKeywords: 'bildkompressor, jpg komprimieren, png komprimieren, bildgröße reduzieren',
      workspaceTitle: 'Bilder komprimieren — photremium.com Bildkompressor',
      workspaceDesc: 'Kompressionsstufe anpassen und optimierte Bilder herunterladen.',
      workspaceKeywords: 'bilder komprimieren, bildkompression',
    },
    title: 'Bildkompressor',
    desc: 'JPG-, PNG- und GIF-Bilder bis zu 80% kleiner komprimieren. Schnell und privat — läuft vollständig in Ihrem Browser.',
    toCompress: 'zum Komprimieren',
    compressionForAll: 'Kompression für alle Bilder',
    summary: 'Zusammenfassung',
    originalSize: 'Originalgröße',
    compressed: 'Komprimiert',
    saved: 'Gespart',
    compressionLabel: 'Kompression:',
    compressing: 'Wird komprimiert…',
    compressDownload: 'Komprimieren & Herunterladen',
    lowQualityWarning: 'Eine hohe Komprimierung kann die Bildschärfe deutlich verringern.',
    blog: {
      tocTitle: 'Inhalt',
      title: 'Bildkompressor-Blog',
      formatsIntro: 'Unser Tool unterstützt alle Bildformate. So können Sie jedes Bild problemlos komprimieren. Die vollständige Liste der Formate finden Sie unten:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Was ist ein Bildkompressor?',
          paragraphs: [
            'Ein Bildkompressor ist ein Tool oder Online-Dienst, der die Dateigröße eines Bildes reduziert und dabei die visuelle Qualität möglichst erhält. Wird ein Bild jedoch zu stark komprimiert, kann die Qualitätsminderung sichtbar werden.',
          ],
          listTitle: 'TYPEN:',
          bullets: [
            'Verlustbehaftete Komprimierung: Dabei wird die Dateigröße reduziert, indem bestimmte Bilddaten entfernt werden. Die Qualität kann sinken, ist aber oft mit dem bloßen Auge kaum erkennbar.',
            'Verlustfreie Komprimierung: Sie reduziert die Dateigröße, ohne die visuelle Bildqualität zu verändern.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Warum unser Tool wählen?',
          bullets: [
            'Unser KI-gestützter Bildkompressor funktioniert nahtlos auf allen Geräten und liefert bestmögliche Ergebnisse.',
            'Sie können mehrere Bilder (sogar 100+) gleichzeitig mit nur einem Klick komprimieren.',
            'Sie müssen keine Bilder auf unsere Server hochladen. Alles wird lokal in Ihrem Browser verarbeitet.',
            'Unser Bildkompressor ist dauerhaft kostenlos. Sie können das Tool auch mit Freunden teilen.',
            'Sie können den Komprimierungsgrad nach Ihren Wünschen festlegen.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Schritt-für-Schritt-Anleitung',
          steps: [
            {
              heading: '1. Wählen Sie die Bilder aus, die Sie komprimieren möchten.',
              bullets: [
                'Ziehen Sie die Bilder per Drag-and-drop in das Upload-Feld.',
                'Sie können Bilder auch mit (Ctrl + V) kopieren und einfügen.',
                'Der Datei-Explorer wird ebenfalls unterstützt, wenn Sie auf die Schaltfläche zum Auswählen klicken.',
              ],
            },
            {
              heading: '2. Wählen Sie anschließend den Komprimierungsprozentsatz.',
              bullets: [
                'Ein horizontaler Schieberegler ermöglicht eine komfortable Auswahl des Komprimierungsgrads. Folgen Sie diesen Bereichen für präzise Ergebnisse.',
              ],
              table: {
                headers: ['Komprimierungsprozentsatz', 'Ergebnisse'],
                rows: [
                  ['1%  bis  40%', 'Beste Qualität'],
                  ['41%  bis  60%', 'Normale Qualität (empfohlen)'],
                  ['61%  bis  100%', 'Schlechte Qualität'],
                ],
              },
            },
            {
              heading: '3. Prüfen Sie den eingesparten Speicher.',
              paragraphs: [
                'Alle Speicherwerte werden in Echtzeit angezeigt. So sehen Sie klar, wie viel Sie insgesamt eingespart haben, und können den Komprimierungsgrad nach Bedarf anpassen.',
              ],
            },
            {
              heading: '4. Wählen Sie über den Umschalter die Download-Option.',
              bullets: [
                'ZIP: Wenn Sie mehrere Bilder komprimieren, sehen Sie diese Option. Bei Auswahl werden alle komprimierten Bilder in einer ZIP-Datei archiviert (empfohlen für viele Bilder).',
                'Einzeln: Diese Option lädt alle Bilder einzeln herunter und nicht als eine ZIP-Datei (empfohlen bei kleiner Anzahl, unter 10).',
              ],
            },
            {
              heading: '5. Komprimieren und herunterladen.',
              paragraphs: [
                'Diese Schaltfläche lädt alle komprimierten Bilder automatisch gemäß der gewählten Download-Option herunter.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Vorteile eines Bildkompressors.',
          bullets: [
            'Geringere Speicherkosten: Komprimierte Bilder benötigen weniger Speicherplatz.',
            'Schnelleres Laden: Komprimierte Bilder laden schneller und verbessern die Nutzererfahrung.',
            'Lösung für Gmail-Limits: Da Gmail Anhänge auf 25MB begrenzt, können Sie durch Komprimierung mehr Dateien versenden.',
            'Schnelleres Teilen und Übertragen: Große Dateien brauchen länger. Komprimierung spart Zeit und Daten und hilft bei Plattform-Limits.',
            'Optimierte Präsentationen: Unkomprimierte Bilder können Präsentationen groß und träge machen; komprimierte Bilder halten Dateigrößen deutlich kleiner.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Unterstützte Formate.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Bildkonverter — PNG, JPG, WEBP, GIF, SVG kostenlos konvertieren | photremium.com',
      uploadDesc: 'Bilder zwischen JPG, PNG, WEBP, GIF, SVG, TIFF, BMP konvertieren. Kostenlos und privat.',
      uploadKeywords: 'bildkonverter, png in jpg, jpg in png, webp konverter',
      workspaceKeywords: 'bilder konvertieren, bildformat konverter',

      routeKeywords: {

        'png-to-jpg': 'png zum Konvertieren jpg, png to jpg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'jpg-to-png': 'jpg zum Konvertieren png, jpg to png, bildkonverter, png in jpg, jpg in png, webp konverter',

        'png-to-webp': 'png zum Konvertieren webp, png to webp, bildkonverter, png in jpg, jpg in png, webp konverter',

        'jpg-to-webp': 'jpg zum Konvertieren webp, jpg to webp, bildkonverter, png in jpg, jpg in png, webp konverter',

        'webp-to-jpg': 'webp zum Konvertieren jpg, webp to jpg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'webp-to-png': 'webp zum Konvertieren png, webp to png, bildkonverter, png in jpg, jpg in png, webp konverter',

        'gif-to-jpg': 'gif zum Konvertieren jpg, gif to jpg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'gif-to-png': 'gif zum Konvertieren png, gif to png, bildkonverter, png in jpg, jpg in png, webp konverter',

        'bmp-to-jpg': 'bmp zum Konvertieren jpg, bmp to jpg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'bmp-to-png': 'bmp zum Konvertieren png, bmp to png, bildkonverter, png in jpg, jpg in png, webp konverter',

        'svg-to-png': 'svg zum Konvertieren png, svg to png, bildkonverter, png in jpg, jpg in png, webp konverter',

        'svg-to-jpg': 'svg zum Konvertieren jpg, svg to jpg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'tiff-to-jpg': 'tiff zum Konvertieren jpg, tiff to jpg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'tiff-to-png': 'tiff zum Konvertieren png, tiff to png, bildkonverter, png in jpg, jpg in png, webp konverter',

        'jpg-to-gif': 'jpg zum Konvertieren gif, jpg to gif, bildkonverter, png in jpg, jpg in png, webp konverter',

        'png-to-gif': 'png zum Konvertieren gif, png to gif, bildkonverter, png in jpg, jpg in png, webp konverter',

        'jpg-to-bmp': 'jpg zum Konvertieren bmp, jpg to bmp, bildkonverter, png in jpg, jpg in png, webp konverter',

        'png-to-bmp': 'png zum Konvertieren bmp, png to bmp, bildkonverter, png in jpg, jpg in png, webp konverter',

        'webp-to-gif': 'webp zum Konvertieren gif, webp to gif, bildkonverter, png in jpg, jpg in png, webp konverter',

        'jpg-to-ico': 'jpg zum Konvertieren ico, jpg to ico, bildkonverter, png in jpg, jpg in png, webp konverter',

        'png-to-ico': 'png zum Konvertieren ico, png to ico, bildkonverter, png in jpg, jpg in png, webp konverter',

        'jpg-to-svg': 'jpg zum Konvertieren svg, jpg to svg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'png-to-svg': 'png zum Konvertieren svg, png to svg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'webp-to-svg': 'webp zum Konvertieren svg, webp to svg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'gif-to-svg': 'gif zum Konvertieren svg, gif to svg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'bmp-to-svg': 'bmp zum Konvertieren svg, bmp to svg, bildkonverter, png in jpg, jpg in png, webp konverter',

        'tiff-to-svg': 'tiff zum Konvertieren svg, tiff to svg, bildkonverter, png in jpg, jpg in png, webp konverter',

      },
    },
    title: 'Bildkonverter',
    desc: 'Bilder zwischen JPG, PNG, WEBP, GIF, SVG, TIFF, BMP und mehr konvertieren. Mehrere Dateien auf einmal batch-konvertieren.',
    toConvert: 'zum Konvertieren',
    convertSettings: 'Konvertierungseinstellungen',
    detected: 'Erkannt',
    convertTo: 'Konvertieren in',
    converting: 'Wird konvertiert…',
    convertToFormat: 'In {format} konvertieren',
    popularConversions: 'Beliebte Konvertierungen',
    convertingTo: 'Konvertierung in',
    all: 'Alle',
  },

  resizer: {
    seo: {
      uploadTitle: 'Bild Größe ändern — JPG, PNG kostenlos skalieren | photremium.com',
      uploadDesc: 'Bildgröße online kostenlos nach Pixel oder Prozent ändern.',
      uploadKeywords: 'bild skalieren, bildgröße ändern',
      workspaceTitle: 'Bilder skalieren — photremium.com',
      workspaceDesc: 'Bildgröße online kostenlos ändern.',
      workspaceKeywords: 'bild skalieren',
    },
    title: 'Bild skalieren',
    desc: 'Abmessungen in Pixel, Prozent, Zentimeter oder Zoll festlegen und Bilder sofort skalieren.',
    toResize: 'zum Skalieren',
    resizeSettings: 'Skalierungseinstellungen',
    resizeBy: 'Skalieren nach:',
    byPixels: 'Nach Pixeln',
    byPercentage: 'Nach Prozent',
    byCentimeters: 'Nach Zentimetern',
    byInches: 'Nach Zoll',
    advanced: 'Erweitert',
    lockAspect: 'Seitenverhältnis sperren',
    unlockAspect: 'Seitenverhältnis entsperren',
    dontEnlarge: 'Nicht vergrößern, wenn das Original kleiner ist',
    resizing: 'Wird skaliert…',
    resizeDownload: 'Skalieren & Herunterladen',
    blog: {
      tocTitle: 'Inhalt',
      title: 'Blog zum Bild-Resizer',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Warum einen Bild-Resizer verwenden?',
          paragraphs: [
            'Ein Bild-Resizer ist ein Tool bzw. eine Software, mit der die Abmessungen eines Bildes geändert werden. Damit können Sie die Größe eines gewünschten Bildes anpassen, indem Sie Höhe, Breite oder beides ändern. Dieses Tool ist besonders nützlich für Social-Media-Plattformen, die Größenbeschränkungen für das Hochladen oder Posten von Bildern haben.',
          ],
          listTitle: 'Zum Beispiel:',
          bullets: [
            'Instagram-Posts: 1080 x 1080px (Quadrat)',
            'Facebook-Post: 1200 x 630px',
            'X (ehemals Twitter) Post: 1200 x 675px',
            'Instagram-Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Warum unser Bild-Resizer-Tool wählen?',
          paragraphs: [
            'Unser KI-gestützter Bild-Resizer macht das Skalieren präzise und extrem schnell. Sie können dieses Tool auf jedem Gerät nahtlos nutzen. Sie müssen keine App installieren oder herunterladen. Alle Dienste sind online in Ihrem bevorzugten Browser verfügbar.',
          ],
          bullets: [
            'Sie können mit unserem Resize-Tool mehrere Bilder (sogar 100+) gleichzeitig skalieren. Mit einem leistungsstarken Gerät lassen sich 400 bis 500 Bilder in wenigen Sekunden bequem skalieren.',
            'Die gesamte Verarbeitung erfolgt in Ihrem lokalen Browser. Sie müssen keine Bilder auf unsere Server hochladen. Ihre Bilder verlassen Ihr Gerät nie. So können Sie persönliche Bilder ohne Datenschutzrisiko skalieren.',
            'Mehrere Einheiten zum Skalieren werden unterstützt.',
            'Sie können das ursprüngliche Seitenverhältnis auch nach dem Skalieren beibehalten, indem Sie einfach das Kontrollkästchen aktivieren.',
            'Wenn Sie mehrere Bilder skalieren, können Sie die Ergebnisse einzeln oder als ZIP-Datei herunterladen.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Schritt-für-Schritt-Anleitung',
          steps: [
            {
              heading: 'Wählen Sie zuerst das Bild oder mehrere Bilder aus, die Sie skalieren möchten. Sie haben mehrere Möglichkeiten, Bilder auszuwählen.',
              bullets: [
                'Sie können Bilder einfach per Drag-and-drop hineinziehen, um sie zu skalieren.',
                'Die Tastenkombination „Ctrl + V“ wird ebenfalls unterstützt, um Bilder in das Feld einzufügen.',
                'Ein Klick auf „Choose Files“ öffnet den Datei-Explorer. Dort können Sie ebenfalls die gewünschten Bilder auswählen.',
              ],
            },
            {
              heading: 'Dann können Sie eine Einheit für die Skalierung wählen. Aktuell bieten wir folgende Einheiten an:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Nach der Einheitsauswahl passen Sie Höhe und Breite an, um das Bild zu skalieren. Sie können das Seitenverhältnis durch Aktivieren des Kontrollkästchens sperren.',
            },
            {
              heading: 'Aktivieren Sie anschließend „Don’t enlarge if original is smaller“, wenn das Bild nicht über seine Originalgröße vergrößert werden soll.',
            },
            {
              heading: 'Danach wählen Sie die Download-Option.',
              bullets: [
                'Wählen Sie ZIP, wenn Sie mehrere Bilder skalieren und alle als eine zip-Datei herunterladen möchten.',
                'Oder wählen Sie „separate“, um jedes skalierte Bild separat herunterzuladen.',
              ],
            },
            {
              heading: 'Klicken Sie dann auf „Resize & Download“, um Ihre skalierten Bilder gemäß der gewählten Download-Option herunterzuladen.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Vorteile des Bild-Resizer-Tools: Der wichtigste Vorteil ist die korrekte Platzierung von Bildern in Webseiten und Social-Media-Posts.',
          tocLabel: '4. Vorteile des Bild-Resizer-Tools',
          bullets: [
            'UX verbessern: Die richtige Größe und Platzierung von Bildern verbessert die Nutzererfahrung deutlich. Zu große oder zu kleine Bilder ohne Anpassung führen zu einer schlechten User Experience.',
            'Social-Media-Unterstützung: Viele Social-Media-Apps haben eigene Größenlimits für Bild-Posts. Unser Bild-Resizer hilft, Bilder auf diese benötigten Maße anzupassen.',
            'Responsive Design: Wenn Sie als Entwickler ein responsives Design erstellen, müssen Bilder in mehreren Größen vorliegen, um verschiedene Geräte zu unterstützen.',
            'Beste Wahl: Statt Bilder zu strecken oder zu beschneiden, was die Abmessungen ungünstig verändern kann, ist ein Bild-Resizer die beste Option.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Unterstützte Formate: Unser Bild-Resizer-Tool erlaubt das Auswählen von Bildern in jedem Format zur Skalierung. Hier sind die Formate:',
          tocLabel: '5. Unterstützte Formate',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Bild zuschneiden — JPG, PNG, GIF kostenlos schneiden | photremium.com',
      uploadDesc: 'JPG-, PNG- und GIF-Bilder online einfach zuschneiden.',
      uploadKeywords: 'bild zuschneiden, jpg schneiden, png schneiden',
      workspaceTitle: 'Bilder zuschneiden — photremium.com',
      workspaceDesc: 'Bilder online kostenlos zuschneiden.',
      workspaceKeywords: 'bild zuschneiden',
    },
    title: 'Bild zuschneiden',
    desc: 'JPG-, PNG-, GIF-Bilder und mehr mit dem visuellen Editor zuschneiden.',
    toCrop: 'zum Zuschneiden',
    cropSettings: 'Zuschneideeinstellungen',
    widthPx: 'Breite (px)',
    heightPx: 'Höhe (px)',
    positionX: 'Position X (px)',
    positionY: 'Position Y (px)',
    cropTemplate: 'Zuschnittsvorlage',
    landscape: 'Querformat',
    portrait: 'Hochformat',
    square: 'Quadrat',
    freeform: 'Frei',
    cropping: 'Wird zugeschnitten…',
    cropDownload: 'Zuschneiden & Herunterladen',
    cropDownloadAll: 'Alle zuschneiden & herunterladen',
    saveNext: 'Speichern & Weiter',
    croppedNofTotal: 'Sie haben {n} von {total} Bildern zugeschnitten.',
    downloadN: '{n} herunterladen',
    blog: {
      tocTitle: 'Inhalt',
      title: 'Bild-Zuschneider-Blog',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Warum einen Bild-Zuschneider verwenden?',
          paragraphs: [
            'Ein Bild-Zuschneider ist ein Software-Tool, das verwendet wird, um das Bild in die gewünschte Form zu schneiden. Es wird häufig verwendet, um einen benötigten Teil des Bildes auszuschneiden und unerwünschte äußere Teile für jeden Zweck zu entfernen. Es bietet ein Zuschneidefeld, das Sie an die Position anpassen können, in der Sie zuschneiden möchten.',
          ],
          listTitle: 'Zum Beispiel:',
          bullets: [
            'Ihr eigenes Bild aus einem Gruppenfoto ausschneiden.',
            'Ihren Namen aus einer Liste ausschneiden.',
            'Die Fortschrittsleiste aus einem Vollbild-Screenshot ausschneiden.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Warum unseren Bild-Zuschneider wählen?',
          paragraphs: [
            'Unser Bild-Zuschneider-Tool ermöglicht es Ihnen, Bilder präzise und sehr schnell zuzuschneiden. Sie müssen nur die Größe des Zuschneidefeldes an die Position anpassen, die Sie aus einem beliebigen Bild ausschneiden möchten. Fast alle Bildformate werden bei der Auswahl des Bildes unterstützt.',
          ],
          bullets: [
            'Sie können so viele Bilder zuschneiden, wie Ihr Gerät unterstützt. Wenn Sie ein leistungsstarkes Gerät haben, können Sie sogar mehr als 100 Bilder gleichzeitig ohne Verzögerung oder andere Probleme zuschneiden.',
            'Ihre Bilder werden in Ihrem lokalen Browser verarbeitet. Es ist nicht nötig, Bilder auf unsere Server hochzuladen, daher verlässt kein Bild Ihr Gerät. Sie können Ihre persönlichen Bilder ohne Unsicherheit oder Risiko zuschneiden.',
            'Viele Tools melden einen Fehler bei ungültigem Bildformat. Unser Bild-Zuschneider-Tool löst dieses Problem, indem es fast alle Bildformate unterstützt.',
            'Wenn Sie mehrere Bilder gleichzeitig zuschneiden, erlaubt unser Tool Ihnen, die zugeschnittenen Bilder als ZIP oder als einzelne Bilder nach Ihrer Präferenz herunterzuladen.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Schritt-für-Schritt-Anleitung',
          steps: [
            {
              heading: '1. Wählen Sie zunächst das Bild aus, das Sie zuschneiden möchten. Das gleichzeitige Auswählen mehrerer Bilder wird von unserem Bild-Zuschneider-Tool ebenfalls unterstützt.',
              bullets: [
                'Ziehen Sie das Bild per Drag-and-drop in das Feld, um es zuzuschneiden.',
                'Sie können das Bild auch über den Datei-Explorer auswählen, indem Sie auf die Schaltfläche Dateien auswählen im Zuschneidefeld klicken.',
                'Die Tastenkombination Ctrl + V wird ebenfalls unterstützt, um die Bilder in das Feld einzufügen.',
              ],
            },
            {
              heading: '2. Passen Sie dann die Größe und Position des Zuschneidefeldes auf dem Bild an, um es auszuschneiden.',
            },
            {
              heading: '3. Sie können das Zuschneidefeld auch anpassen, indem Sie die Werte für Höhe, Breite, horizontale Position und vertikale Position manuell eingeben.',
            },
            {
              heading: '4. Sie können auch einige vorgefertigte Vorlagen verwenden:',
              bullets: [
                'Querformat(16:9)',
                'Hochformat(9:16)',
                'Quadrat(1:1)',
              ],
            },
            {
              heading: '5. Dann müssen Sie eine der Download-Optionen auswählen.',
              bullets: [
                'ZIP: Wählen Sie diese Option, wenn Sie mehrere Bilder zuschneiden und alle zugeschnittenen Bilder als eine einzelne Datei herunterladen möchten.',
                'Einzeln: Wenn Sie alle zugeschnittenen Bilder einzeln herunterladen möchten, wählen Sie diese Option über die Umschaltfläche.',
              ],
            },
            {
              heading: '6. Klicken Sie dann auf die Schaltfläche Zuschneiden & Herunterladen, um alle zugeschnittenen Bilder gemäß Ihren voreingestellten Abmessungen herunterzuladen.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Vorteile des Bild-Zuschneiders: Das Bild-Zuschneider-Tool bietet mehrere Vorteile in der digitalen Welt. Einige werden unten beschrieben:',
          tocLabel: '4. Vorteile des Bild-Zuschneiders',
          bullets: [
            'Einpassen von Bildern in Rahmen: Der Bild-Zuschneider hilft Ihnen, Bilder korrekt in Rahmen einzupassen. Diese Rahmen können entweder auf einer Webseite oder auf einer Social-Media-Plattform sein.',
            'Verbesserung der UX: Da die korrekte Platzierung von Bildern die Benutzererfahrung verbessert, hilft der Bild-Zuschneider dabei, die UX in hohem Maß zu verbessern.',
            'Entfernen unerwünschter Ränder: Sie können unerwünschte Ränder von einem Bild entfernen, um es zu verfeinern.',
            'Trennung des gewünschten Objekts: Sie können Ihr Bild auch aus einem Gruppenfoto trennen.',
            'Speicher sparen: Das Zuschneiden des Bildes spart definitiv Speicher, da der rohe Bereich des Bildes abgeschnitten wird und nur der gewünschte Teil gespeichert wird.',
            'Präsentation optimieren: Da eine normale Präsentation mit 10 unbeschnittenen Bildern fast 30MB Speicher benötigt, kann dieselbe Präsentation mit zugeschnittenen Bildern fast 10MB Speicher benötigen.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Unterstützte Formate:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Foto-Editor — Fotos kostenlos online bearbeiten | photremium.com',
      desc: 'Fotos online kostenlos bearbeiten — Text, Effekte, Rahmen und mehr hinzufügen.',
      keywords: 'foto-editor, fotos online bearbeiten',
    },
    title: 'Foto-Editor',
    desc: 'Text, Effekte, Rahmen und Aufkleber zu Bildern hinzufügen.',
    toEdit: 'zum Bearbeiten',
    textTypography: 'Text & Typografie',
    textTypographyDesc: 'Benutzerdefinierten Text mit verschiedenen Schriftarten, Farben und Schatten hinzufügen.',
    filtersEffects: 'Filter & Effekte',
    filtersEffectsDesc: 'Professionelle Filter anwenden, Helligkeit, Kontrast und Sättigung anpassen.',
    framesStickers: 'Rahmen & Aufkleber',
    framesStickersDesc: 'Schöne Rahmen und lustige Aufkleber zur Bildverbesserung wählen.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Bildhintergrund kostenlos entfernen | photremium.com',
      uploadDesc: 'Bildhintergründe schnell und präzise entfernen. Kostenlos — läuft in Ihrem Browser.',
      uploadKeywords: 'hintergrund entfernen, bild hintergrund entfernen, transparenter hintergrund',
      workspaceTitle: 'Hintergründe entfernen — photremium.com',
      workspaceDesc: 'Bildhintergründe kostenlos online entfernen.',
      workspaceKeywords: 'hintergrund entfernen',
    },
    title: 'Hintergrund entfernen',
    desc: 'Bildhintergründe sofort entfernen. 100% kostenlos, läuft in Ihrem Browser.',
    toRemoveBg: 'Hintergrund entfernen',
    backgroundRemover: 'Hintergrundentferner',
    processingProgress: 'Verarbeitungsfortschritt',
    processingNImages: '{n} Bild(er) wird verarbeitet…',
    allNProcessed: 'Alle {n} Bild(er) verarbeitet!',
    nOfTotalDone: '{n} / {total} fertig',
    fileName: 'Dateiname',
    dimensions: 'Abmessungen',
    status: 'Status',
    statusDone: '✓ Fertig',
    statusProcessing: '⏳ Verarbeitung',
    statusError: '✗ Fehler',
    statusPending: '⏸ Ausstehend',
    badgeDone: 'Fertig',
    badgeProcessing: 'Wird verarbeitet…',
    badgeError: 'Fehler',
    removingBg: 'Hintergrund wird entfernt…',
    retry: 'Erneut versuchen',
    downloading: 'Wird heruntergeladen…',
    nextImage: 'Nächstes Bild',
  },

  watermark: {
    seo: {
      uploadTitle: 'Wasserzeichen online hinzufügen kostenlos | photremium.com',
      uploadDesc: 'Text- oder Bildwasserzeichen zu Fotos hinzufügen. Kostenlos und schnell.',
      uploadKeywords: 'wasserzeichen, wasserzeichen hinzufügen',
      workspaceTitle: 'Wasserzeichen hinzufügen — photremium.com',
      workspaceDesc: 'Wasserzeichen kostenlos online hinzufügen.',
      workspaceKeywords: 'wasserzeichen',
    },
    title: 'Wasserzeichen hinzufügen',
    desc: 'Text- oder Logo-Wasserzeichen zu Bildern hinzufügen.',
    toWatermark: 'für Wasserzeichen',
    watermarkTools: 'Wasserzeichen-Werkzeuge',
    addText: 'Text hinzufügen',
    addImage: 'Bild hinzufügen',
    layersN: 'Ebenen ({n})',
    noLayers: 'Noch keine Ebenen hinzugefügt',
    textLayer: 'Textebene',
    imageLayer: 'Bildebene',
    watermarkDownloadAll: 'Wasserzeichen & Alle herunterladen',
    watermarkDownload: 'Wasserzeichen & Herunterladen',
    nextImage: 'Nächstes Bild',
    privateMode: 'Privater Modus',
    privateModeOn: 'Privater Modus AN: Wasserzeichen nur verschieben und skalieren…',
    privateModeHint: 'Privaten Modus aktivieren, um nur Position und Größe anzupassen…',
    privateModeActive: 'Privater Modus — nur Verschieben, Skalieren und Schriftgröße erlaubt',
    selectToEdit: 'Bild oder Text auswählen, um mit der Bearbeitung zu beginnen',
    bold: 'Fett',
    italic: 'Kursiv',
    underline: 'Unterstreichen',
    bgColor: 'Hintergrundfarbe',
    textColor: 'Textfarbe',
    alignLeft: 'Linksbündig',
    alignCenter: 'Zentriert',
    alignRight: 'Rechtsbündig',
    opacity: 'Deckkraft',
    stroke: 'Kontur',
    strokeWidth: 'Konturbreite',
    strokeColor: 'Konturfarbe',
    tileRepeat: 'Kacheln / Wiederholen',
    tilePattern: 'Kachelmuster',
    spacing: 'Abstand',
    snapToCenter: 'Am Mittelpunkt einrasten',
    duplicate: 'Duplizieren',
    delete: 'Löschen',
    flipHorizontal: 'Horizontal spiegeln',
    flipVertical: 'Vertikal spiegeln',
    rotateLeft: 'Nach links drehen',
    rotateRight: 'Nach rechts drehen',
    cornerRadius: 'Eckenradius',
    borderStroke: 'Rand / Kontur',
    borderWidth: 'Randbreite',
    color: 'Farbe',
    style: 'Stil',
    hide: 'Ausblenden',
    show: 'Einblenden',
    lock: 'Sperren',
    unlock: 'Entsperren',
    solid: 'Durchgehend',
    dashed: 'Gestrichelt',
    dotted: 'Gepunktet',
    double: 'Doppelt',
    tileSingle: 'Einzeln',
    tile2x2: '2×2 Raster',
    tile3x3: '3×3 Raster',
    removeAllConfirm: 'Alle Bilder und Wasserzeichen entfernen?',
    dimMismatch: 'Die hochgeladenen Bilder haben unterschiedliche Abmessungen. Für beste Ergebnisse Bilder mit gleicher Auflösung hochladen.',
    clearBackground: 'Hintergrund löschen',
    typeHere: 'Hier eingeben...',
    linkCorners: 'Ecken verbinden',
    separateCorners: 'Ecken trennen',
    blog: {
      tocTitle: 'Inhalt',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Tool-Überblick',
          title: 'So fügen Sie Ihren Bildern online ein Wasserzeichen hinzu — Der komplette Guide zum Wasserzeichen-Tool von Photremium',
          paragraphs: [
            'Sie haben gerade ein wunderschönes Foto fertig bearbeitet. Vielleicht ist es ein Produktbild für Ihren Shop, ein Porträt aus einer Kundensession oder ein digitales Artwork, an dem Sie stundenlang gefeilt haben. Und jetzt kommt die Frage, der sich jeder Creator irgendwann stellt: Wie schützen Sie es, bevor Sie es teilen?',
            'Die Antwort, auf die die meisten Profis kommen, lautet: Wasserzeichen — aus gutem Grund. Ein richtig platziertes Wasserzeichen wirkt wie eine dauerhafte Signatur, macht Ihre Arbeit nachvollziehbar und gebrandet und erschwert Diebstahl erheblich.',
            'Das Problem, auf das viele stoßen: Online-Tools sind entweder zu umständlich, hinter Abos versteckt oder setzen ein so schweres Wasserzeichen, dass das Bild leidet.',
            'Das Wasserzeichen-Tool von Photremium wurde genau dafür gebaut. Es läuft vollständig im Browser, ist kostenlos, ohne Konto nutzbar und lädt Ihre Dateien niemals auf einen Server hoch. Alles bleibt lokal, alles bleibt schnell, und der kreative Kontrollgrad konkurriert mit Desktop-Software. In diesem Guide zeigen wir Ihnen, wie es funktioniert, für wen es gedacht ist und wie Sie jedes Mal die besten Ergebnisse erzielen.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Was ist ein Wasserzeichen',
          title: 'Was ist ein Wasserzeichen und warum ist es wichtig?',
          paragraphs: [
            'Bevor wir ins Tool eintauchen, lohnt es sich zu verstehen, was ein Wasserzeichen leistet und warum so viele Fotografen, Designer und Content Creator es für unverzichtbar halten.',
            'Ein Wasserzeichen ist eine sichtbare Überlagerung in einem Bild — meist Text, Logo oder Copyright-Symbol — die den Urheber oder Eigentümer identifiziert. Im Gegensatz zu Metadaten (die im File verborgen sind und in Sekunden entfernt werden können) ist ein Wasserzeichen visuell in das Bild eingebettet. Man kann es nicht einfach mit Rechtsklick entfernen, ohne die Bildqualität sichtbar zu beeinträchtigen.',
          ],
          subSections: [
            {
              title: 'Warum Creators Wasserzeichen nutzen',
              paragraphs: [
                'Die praktischen Gründe für Wasserzeichen lassen sich auf drei Kernpunkte reduzieren.',
              ],
              bullets: [
                'Eigentumskennzeichnung. Wenn Ihre Arbeit in sozialen Netzwerken, Pinterest-Boards oder Blogposts geteilt wird, geht die ursprüngliche Zuordnung oft verloren. Ein Wasserzeichen stellt sicher, dass Ihr Name oder Ihre Marke mit dem Bild mitwandert.',
                'Diebstahlabschreckung. Die meisten Bilddiebe suchen den einfachsten Weg. Ein professionelles, gut platziertes und leicht transparentes Wasserzeichen sendet ein klares Signal: Dieses Bild gehört jemandem, der seine Arbeit schützt.',
                'Schutz von Kundenportfolios. Fotografen, die Vorschauen vor der finalen Zahlung teilen, nutzen Wasserzeichen, um unautorisierte Nutzung zu verhindern. Ein dezentes Wasserzeichen schützt, ohne die Beurteilung zu stören.',
              ],
            },
            {
              title: 'Wer sollte Wasserzeichen verwenden?',
              paragraphs: [
                'Wenn Sie in eine der folgenden Kategorien fallen, ist Wasserzeichen vor dem Teilen kein „Nice-to-have“, sondern Pflicht:',
              ],
              bullets: [
                'Freelance-Fotografen, die Galerien mit Kunden teilen',
                'Grafikdesigner, die Portfolio-Samples veröffentlichen',
                'E-Commerce-Verkäufer, die Produktfotos vor Lizenzierung zeigen',
                'Digitale Künstler, die in sozialen Netzwerken posten',
                'Blogger und Content Creator, deren Bilder häufig weiterverwendet werden',
                'Stockfoto-Autoren, die eine wiedererkennbare Marke aufbauen',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Arbeitsbereich',
          title: 'Im Wasserzeichen-Tool von Photremium: Ein Drei-Panel-Workspace für echte Workflows',
          paragraphs: [
            'Was das Photremium-Wasserzeichen-Tool von einfachen Online-Wasserzeichnern unterscheidet, ist sein Workspace-Design. Statt eines simplen „Text tippen, Position wählen, fertig“ bietet es ein Drei-Panel-Layout wie in professioneller Designsoftware — nur eben im Browser, ohne Installation.',
          ],
          subSections: [
            {
              title: 'Das linke Canvas-Panel',
              paragraphs: [
                'Das Canvas-Panel nimmt den größten Teil des Bildschirms ein und zeigt Ihr Bild mit Wasserzeichen in Echtzeit. Jede Änderung — Deckkraft, Textposition, Logo-Größe — erscheint sofort. Kein „Vorschau“-Button. What you see is what you get.',
                'Das Canvas enthält zudem eine Zoom-Leiste zum präzisen Ausrichten. Die Zoom-to-fit-Funktion berechnet automatisch die beste Anfangsgröße für Ihren Bildschirm, sodass auch hochauflösende Bilder komfortabel angezeigt werden. Ausrichtungshilfen erscheinen dynamisch, wenn Sie einen Layer nahe der horizontalen oder vertikalen Mitte bewegen, und snappen das Wasserzeichen exakt zentriert — wie in Photoshop.',
              ],
            },
            {
              title: 'Das rechte Einstellungen-Panel',
              paragraphs: [
                'Das rechte Panel ist die Schaltzentrale. Hier verwalten Sie Ihre Wasserzeichen-Layer, passen deren Aussehen an und starten den Export. Auf dem Desktop sitzt es fix rechts. Auf mobilen Geräten erscheint es als Bottom Sheet über einen schwebenden Zahnrad-Button, ohne die Leinwand zu verdecken.',
                'Im rechten Panel finden Sie den Layer-Manager, der jedes Element auflistet. Jede Zeile zeigt den Layer-Typ (Text oder Bild), den aktuellen Namen oder Inhalt sowie drei Schnellaktionen: Sichtbarkeit (Augen-Symbol), Sperren (Position fixieren) und Löschen.',
              ],
            },
            {
              title: 'Die linke Vorschauleiste (Multi-Image-Modus)',
              paragraphs: [
                'Wenn Sie mehrere Bilder auf einmal bearbeiten — etwa Produktfotos oder eine komplette Session — erscheint links eine vertikale Thumbnail-Leiste. Das ist die Bild-Warteschlange. Ein Klick auf ein Thumbnail lädt das Bild sofort ins Canvas, ohne Ihre Layer-Einstellungen zu verlieren.',
                'Die Leiste zeigt außerdem Dateigröße in KB/MB sowie das Format (JPG, PNG, WEBP), damit Sie jederzeit wissen, womit Sie arbeiten.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Schritt für Schritt',
          title: 'Schritt für Schritt: So fügen Sie ein Wasserzeichen hinzu',
          paragraphs: [
            'Diese Anleitung folgt genau dem tatsächlichen Ablauf des Tools — vom Drag-and-Drop-Upload bis zum Canvas-Rendern vor dem Download.',
          ],
          steps: [
            {
              heading: 'Schritt 1 — Bild(er) hochladen',
              paragraphsBefore: [
                'Öffnen Sie photremium.com/watermark-image. Sie sehen eine saubere Dropzone in der Mitte der Seite.',
                'Es gibt drei Wege, Ihre Bilder zu laden:',
              ],
              bullets: [
                'Drag & Drop. Ziehen Sie ein oder mehrere Bilddateien in die Dropzone. Das Tool akzeptiert JPEG, PNG, WEBP und mehr. Beim Draggen erscheint ein violetter Rahmen mit dem Hinweis „Drop images to add for watermarking“.',
                'Klicken & auswählen. Klicken Sie auf „Choose Files“, um den Dateiauswahldialog zu öffnen. Mehrfachauswahl ist mit Ctrl+Click (Windows) oder Cmd+Click (Mac) möglich.',
                'Aus der Zwischenablage einfügen. Wenn Sie ein Bild kopiert haben, drücken Sie Ctrl+V (Cmd+V auf Mac) — das Bild wird direkt geladen, auch wenn bereits mehrere Bilder vorhanden sind.',
              ],
              paragraphsAfter: [
                'Sobald das erste Bild geladen ist, wechselt die Ansicht in den vollen Drei-Panel-Editor, und das Bild erscheint im automatisch berechneten Zoom-to-fit.',
              ],
            },
            {
              heading: 'Schritt 2 — Text-Wasserzeichen hinzufügen',
              paragraphsBefore: [
                'Klicken Sie im rechten Panel auf den lila „Add Text“-Button. Ein neuer Text-Layer erscheint mit dem Platzhalter „Type here...“.',
                'Sie können sofort los tippen. Der Text wird live im Canvas angezeigt. In der oberen Toolbar können Sie alles anpassen:',
              ],
              bullets: [
                'Font family — Auswahl aus 12 integrierten Fonts wie Arial, Georgia, Impact, Brush Script MT, Comic Sans MS u. a.',
                'Font size — Pixelwert direkt eingeben oder per Controls verändern',
                'Bold, italic, underline — Kombination aus Stilen',
                'Text color — Farbe per Picker wählen',
                'Background color — farbiger Hintergrund hinter Text für Label/Badge',
                'Stroke (outline) — Kontur für bessere Lesbarkeit auf hellen/dunklen Bildern',
                'Opacity — von 0% bis 100%; die meisten Wasserzeichen liegen bei 30–60%',
                'Alignment — links, zentriert oder rechts ausrichten',
                'Rotation — beliebiger Winkel mit Snap-Punkten bei 0°, 90°, 180°, 270°',
              ],
              paragraphsAfter: [
                'Zum Verschieben ziehen Sie den Text. Für pixelgenaue Positionierung nutzen Sie die Pfeiltasten (Shift für 10 px). Zum Skalieren ziehen Sie die acht Handles am Rand.',
              ],
            },
            {
              heading: 'Schritt 3 — Bild- (Logo-)Wasserzeichen hinzufügen',
              paragraphsBefore: [
                'Wenn Sie ein Logo oder eine Signatur verwenden möchten, klicken Sie auf „Add Image“ im rechten Panel und wählen Sie die Datei. Das Tool skaliert das Logo automatisch auf ca. 30% der Canvas-Breite und zentriert es.',
                'Danach können Sie es frei positionieren, über Eckgriffe skalieren (mit fixem Seitenverhältnis) oder mit dem Rotationsgriff drehen. Für Bild-Layer stehen zusätzliche Controls zur Verfügung:',
              ],
              bullets: [
                'Opacity — wie bei Text, ideal für transparente PNG-Logos',
                'Flip horizontal / Flip vertical — Spiegelung',
                'Border width, border color, border style — sichtbarer Rahmen',
                'Border radius — Ecken abrunden, einheitlich oder pro Ecke',
                'Rotation — gleiches Drehverhalten wie bei Text',
              ],
            },
            {
              heading: 'Schritt 4 — Tiling (optional)',
              paragraphsBefore: [
                'Eine der stärksten Funktionen ist Tiling — das Wiederholen Ihres Wasserzeichens in einem Raster über das gesamte Bild. Das ist ideal, wenn Sie eine Weiterverwendung verhindern möchten.',
                'Wählen Sie einen Layer und setzen Sie Tile auf:',
              ],
              bullets: [
                'None — Einzelplatzierung (Standard)',
                'Grid 2×2 — Wiederholung im 2x2-Raster',
                'Grid 3×3 — Wiederholung im 3x3-Raster',
              ],
              paragraphsAfter: [
                'Sie können außerdem den Abstand zwischen den Kacheln einstellen. Das Canvas zeigt Ghost-Previews aller Kopien.',
              ],
            },
            {
              heading: 'Schritt 5 — Layer-Manager nutzen',
              paragraphsBefore: [
                'Sie können beliebig viele Layer hinzufügen. Der Layer-Manager listet sie alle. Sie können:',
              ],
              bullets: [
                'Layer über das Augen-Icon ein-/ausblenden',
                'Layer sperren, um versehentliches Verschieben zu verhindern',
                'Layer löschen',
              ],
              paragraphsAfter: [
                'Ein Klick auf einen Layer in der Liste wählt ihn gleichzeitig auf dem Canvas aus.',
              ],
            },
            {
              heading: 'Schritt 6 — Zwischen mehreren Bildern wechseln',
              paragraphsBefore: [
                'Wenn Sie mehrere Bilder hochgeladen haben, verwenden Sie die Thumbnail-Leiste links. Ihre Layer-Einstellungen gelten für alle Bilder beim Export.',
                'Das Tool prüft auch auf unterschiedliche Auflösungen. Bei Abweichungen über 5% erscheint ein Hinweis. Die Platzierung wird proportional übertragen, sodass der Wasserzeichen-Look konsistent bleibt.',
              ],
            },
            {
              heading: 'Schritt 7 — Download-Einstellungen wählen',
              paragraphsBefore: [
                'Für einzelne Bilder klicken Sie auf „Download“ unter dem Canvas. Der Dateiname erhält automatisch „-watermarked“. JPEGs werden mit 0.95 Qualität exportiert, PNGs bleiben verlustfrei.',
                'Für Batch-Jobs stehen zwei Modi im rechten Panel zur Verfügung:',
              ],
              bullets: [
                'ZIP — alle Bilder in einer ZIP-Datei',
                'Separate — jedes Bild wird einzeln heruntergeladen',
              ],
            },
            {
              heading: 'Schritt 8 — Download und Kontrolle',
              paragraphsBefore: [
                'Beim Download rendert das Tool jedes Bild auf einer versteckten Canvas in voller Originalauflösung — nicht in der Bildschirmvorschau. So erhalten Sie die exakten Pixelmaße mit korrekt skalierter Wasserzeichenposition. Öffnen Sie die Datei und zoomen Sie hinein, um das Ergebnis zu prüfen.',
                'Wenn etwas nicht passt, kehren Sie zurück, passen Sie an und laden Sie erneut herunter.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Pro Tipps',
          title: 'Pro-Tipps für beste Ergebnisse',
          bullets: [
            'Verwenden Sie ein halbtransparentes PNG-Logo. Ein Logo-Wasserzeichen mit 40–50% Deckkraft wirkt deutlich professioneller als Volltext.',
            'Platzieren Sie das Wasserzeichen dort, wo ein Zuschnitt Wert zerstört. Die rechte untere Ecke ist am häufigsten — und am leichtesten zu entfernen. Für mehr Schutz legen Sie es über einen wichtigen Bildbereich. Diagonales Tiling ist noch schwerer zu entfernen.',
            'Nutzen Sie die Sperre bei mehreren Layern. Wenn die Hauptposition sitzt, sperren Sie den Layer, bevor Sie weitere hinzufügen.',
            'Testen Sie helle und dunkle Bereiche. Weißer Text verschwindet auf hellem Himmel, ist aber auf Schatten lesbar. Eine feine Kontur oder Hintergrundfarbe sorgt für bessere Lesbarkeit.',
            'Tastenkürzel sparen Zeit. Pfeiltasten bewegen 1 px, Shift+Arrow 10 px. Delete löscht den Layer sofort.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Datenschutz',
          title: 'Datenschutz & Sicherheit: Warum Browser-Verarbeitung wichtig ist',
          paragraphs: [
            'Viele Creator fragen sich, wohin ihre Bilder bei Online-Tools wandern. Bei serverbasierten Wasserzeichnern wird das Bild hochgeladen, dort verarbeitet und zurückgesendet. Das bedeutet: unveröffentlichte Arbeiten laufen über fremde Infrastruktur.',
            'Das Photremium-Tool verarbeitet alles lokal im Browser. Bilder werden via File API in den Gerätespeicher geladen und niemals übers Internet übertragen. Das Rendern erfolgt per HTML5 Canvas innerhalb des Tabs. Beim Schließen oder „Start Over“ wird der Speicher freigegeben. Nichts wird außerhalb Ihres Geräts gespeichert.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Zusammenfassung',
          title: 'Warum das Wasserzeichen-Tool von Photremium einen festen Platz im Workflow verdient',
          paragraphs: [
            'Es gibt Dutzende Wasserzeichen-Tools. Ob eines sich lohnt, entscheidet meist die Kombination aus Geschwindigkeit, Kontrolle und Vertrauen.',
            'Geschwindigkeit zählt, denn Wasserzeichen sollten keinen großen Zeitverlust verursachen. Photremium lädt sofort, verarbeitet lokal und exportiert in voller Auflösung in Sekunden — selbst bei großen Stapeln. Keine Server-Warteschlangen, keine Wartezeiten.',
            'Kontrolle zählt, denn ein schlechtes Wasserzeichen wirkt unprofessionell. Das Layer-System, die Property-Controls, das Live-Preview und die Shortcuts bieten Kontrolle auf Desktop-Niveau.',
            'Vertrauen zählt, weil unveröffentlichte Arbeiten wertvoll sind. Wenn Ihre Bilder nie das Gerät verlassen, können Sie Kundenfotos, unreleased Produktbilder oder sensibles Material ohne Sorgen bearbeiten.',
            'Egal ob ein einzelnes Foto mit Copyright oder ein Batch von 200 Bildern — das Photremium-Wasserzeichen-Tool liefert die richtige Lösung: vollständig kostenlos, vollständig privat und flexibel genug, damit der Wasserzeichen-Look zur Bildästhetik passt.',
            'Besuchen Sie photremium.com/watermark-image und probieren Sie es aus. Ihr erstes Wasserzeichen ist in 30 Sekunden fertig.',
            'Photremium bietet eine Suite browserbasierter Bildtools. Alle Tools laufen lokal — Ihre Bilder bleiben auf Ihrem Gerät.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'QR-Code Generator — Kostenlos erstellen & anpassen | photremium.com',
      inputDesc: 'Benutzerdefinierte QR-Codes für URLs, Text, WLAN, Kontakte, E-Mail und Google Maps erstellen.',
      inputKeywords: 'qr-code generator, qr-code erstellen',
      customizeTitle: 'QR-Code anpassen — photremium.com',
      customizeDesc: 'Stil, Farbe, Rahmen und Logo des QR-Codes anpassen.',
      customizeKeywords: 'qr-code anpassen, qr-code farben',
    },
    title: 'QR-Code Generator',
    desc: 'QR-Codes für URLs, Text, WLAN, Kontakte, E-Mail & Karten generieren, anpassen und herunterladen.',
    generate: 'Generieren',
    scanQrCode: 'QR-Code scannen',
    tabUrl: 'Link / URL',
    tabText: 'Text',
    tabWifi: 'WLAN',
    tabContact: 'Kontakt',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'URL eingeben',
    enterText: 'Text eingeben',
    networkName: 'Netzwerkname (SSID)',
    password: 'Passwort',
    encryption: 'Verschlüsselung',
    hiddenNetwork: 'Verstecktes Netzwerk',
    contactName: 'Kontaktname (optional)',
    phoneNumber: 'Telefonnummer',
    emailAddress: 'E-Mail-Adresse',
    subject: 'Betreff (optional)',
    body: 'Inhalt (optional)',
    searchLocation: 'Ort suchen',
    urlPlaceholder: 'https://beispiel.de',
    textPlaceholder: 'Text hier eingeben…',
    wifiNamePlaceholder: 'Mein WLAN',
    passwordPlaceholder: 'Passwort',
    contactPlaceholder: 'Max Mustermann',
    phonePlaceholder: '+49 XXX XXXXXXXX',
    emailPlaceholder: 'beispiel@gmail.com',
    subjectPlaceholder: 'Betreff',
    bodyPlaceholder: 'E-Mail-Text…',
    locationPlaceholder: 'Stadt, Adresse, Ort suchen…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Keine',
    characters: 'Zeichen',
    qrGettingComplex: 'QR-Code wird komplex — möglicherweise schwer zu scannen.',
    qrTooComplex: 'QR-Code zu komplex! Die meisten Scanner können ihn nicht lesen.',
    generateCustomize: 'Generieren & Anpassen',
    editQrData: 'QR-Daten bearbeiten',
    styleShape: 'Stil & Form',
    colorTab: 'Farbe',
    framesTab: 'Rahmen',
    logoTab: 'Logo',
    templatesTab: 'Vorlagen',
    fileFormatTab: 'Dateiformat',
    dotShape: 'Punktform',
    cornerEyeOuter: 'Eckauge — Außen',
    cornerEyeInner: 'Eckauge — Innen',
    fgColor: 'Vordergrundfarbe',
    bgColor: 'Hintergrundfarbe',
    enableGradient: 'Verlauf aktivieren',
    gradientType: 'Verlaufstyp',
    linear: 'Linear',
    radial: 'Radial',
    gradientColor1: 'Verlaufsfarbe 1',
    gradientColor2: 'Verlaufsfarbe 2',
    suggestedGradients: 'Vorgeschlagene Verläufe',
    selectFrame: 'Rahmen auswählen',
    selectLogo: 'Logo auswählen',
    uploadCustomLogo: 'Oder benutzerdefiniertes Logo hochladen',
    uploadImage: 'Bild hochladen',
    customLogoApplied: 'Benutzerdefiniertes Logo angewendet',
    premadeTemplates: 'Fertige Vorlagen',
    templateHint: 'Vorlage anklicken, um ihre Stilkombination sofort anzuwenden.',
    downloadFormat: 'Downloadformat',
    fgBgIdentical: 'Vordergrund- und Hintergrundfarbe sind identisch — QR-Code wird unsichtbar!',
    fgBgSimilar: 'Vordergrund- und Hintergrundfarbe sind sehr ähnlich — QR-Code möglicherweise schwer zu scannen.',
    preview: 'Vorschau',
    angle: 'Winkel',
    downloadFormatBtn: '{format} herunterladen',
    pngDesc: 'Verlustfrei, Transparenzunterstützung',
    jpgDesc: 'Beliebtes/universelles Dateiformat',
    webpDesc: 'Modernes Format, bestes Qualitäts-/Größenverhältnis',
    svgDesc: 'Skalierbare Vektorgrafik',
    pdfDesc: 'Druckfertiges Dokument',
    lat: 'Breitengrad:',
    lng: 'Längengrad:',
    qrCode: 'QR-Code',
    scanMe: 'SCANNEN',
    scanHere: 'HIER SCANNEN',
    blog: {
      card1: {
        title: '1. Was ist ein QR-Code?',
        intro1: 'QR steht für „Quick Response“. Die enthaltenen Informationen können sehr schnell von Geräten gelesen werden.',
        intro2: 'Ein QR-Code ist ein zweidimensionaler Code für Maschinen. Er kann Texte, Kontaktdaten, Links, Kartenpositionen und weitere Daten speichern.',
        inventionTitle: 'Wie der QR-Code erfunden wurde:',
        inventionText: 'Der QR-Code wurde 1994 von Masahiro Hara und seinem Team bei Denso Wave in Japan entwickelt, um deutlich mehr Daten als ein klassischer Barcode zu erfassen.',
        keyFeaturesTitle: 'Wichtige Merkmale eines QR-Codes',
        keyFeatures: [
          {
            title: 'So funktioniert QR',
            text: 'Sie geben Text oder einen Link ein, und daraus wird ein Muster aus Quadraten erzeugt. Jedes Modul steht für Datenbits.',
          },
          {
            title: 'Aufbau des QR-Codes',
            text: 'Drei große Eckmarken bestimmen die Ausrichtung; viele kleine Module enthalten die eigentlichen Informationen.',
          },
          {
            title: 'Datenkapazität des QR-Codes',
            text: 'QR-Codes speichern in der Regel mehr Daten als eindimensionale Barcodes. Bei sehr vielen Zeichen steigt die Komplexität und die Scanbarkeit kann sinken.',
          },
          {
            title: 'Fehlererkennung bei QR-Codes',
            text: 'Auch bei kleinen Beschädigungen kann ein QR-Code oft gelesen werden. Fehlerkorrektur hilft, fehlende Teile zu rekonstruieren.',
          },
        ],
        errorTitle: 'Fehlerkorrekturstufen des QR-Codes:',
        errorIntro: 'Je nach Einsatz werden unterschiedliche Korrekturstufen verwendet:',
        errorHeaders: {
          level: 'Stufe',
          recovery: 'Wiederherstellung',
          bestUse: 'Beste Verwendung',
        },
        errorRows: [
          {
            level: 'Niedrig (L)',
            recovery: '~7%',
            useCases: [
              'Geeignet für digitale Anzeigen, Websites oder saubere Umgebungen mit geringem Risiko.',
              'Ideal für kurze Inhalte wie E-Mail-Adresse, Telefonnummer oder kurzen Text.',
            ],
          },
          {
            level: 'Mittel (M)',
            recovery: '~15%',
            useCases: [
              'Passend für Flyer und Poster in normalen Bedingungen.',
            ],
          },
          {
            level: 'Quartil (Q)',
            recovery: '~25%',
            useCases: [
              'Empfohlen für Außenbereiche oder rauere Umgebungen.',
              'Sinnvoll, wenn ein kleines Logo in der Mitte einen Teil der Module überdeckt.',
            ],
          },
          {
            level: 'Hoch (H)',
            recovery: '~30%',
            useCases: [
              'Nützlich bei höherem Risiko für Beschädigungen.',
              'Geeignet bei größeren Logos im Zentrum des Codes.',
              'Empfohlen für stark gestaltete QR-Designs.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Warum unseren QR-Code-Generator wählen?',
        intro: 'Unser Generator erstellt QR-Codes schnell, sicher und unkompliziert. Sie können Design und Stil kostenlos an Ihr Branding anpassen.',
        strengths: [
          {
            title: 'Professionelle Anpassung:',
            text: 'Erstellen und gestalten Sie beliebig viele QR-Codes ohne Kosten mit vielen Optionen für Formen, Farben und Verläufe.',
          },
          {
            title: 'Unterstützung mehrerer Formate:',
            text: 'Vor dem Download wählen Sie einfach das gewünschte Dateiformat aus.',
          },
          {
            title: 'Vorgefertigte Vorlagen:',
            text: 'Nutzen Sie fertige Farbverläufe und Rahmen für ein professionelles Erscheinungsbild.',
          },
          {
            title: 'Eigene Logos:',
            text: 'Laden Sie Ihr Markenlogo hoch oder wählen Sie ein Logo aus der integrierten Bibliothek.',
          },
          {
            title: 'Live-Vorschau:',
            text: 'Alle Änderungen werden in Echtzeit direkt in der Vorschau angezeigt.',
          },
          {
            title: 'Scan-Hinweise:',
            text: 'Warnungen helfen bei der Auswahl scanfreundlicher Farbkombinationen.',
          },
        ],
        formatHeaders: {
          srNo: 'Nr.',
          formats: 'Formate',
          description: 'Beschreibung',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Verlustfrei, mit Transparenz' },
          { no: '2', format: 'JPG', description: 'Beliebtes, universelles Dateiformat' },
          { no: '3', format: 'WEBP', description: 'Modernes Format mit starkem Qualitäts-/Größenverhältnis' },
          { no: '4', format: 'SVG', description: 'Skalierbare Vektorgrafik' },
          { no: '5', format: 'PDF', description: 'Druckfertiges Dokument' },
        ],
      },
      card3: {
        title: '3. Schritt-für-Schritt-Anleitung:',
        step1Intro: 'Wählen Sie zuerst die gewünschte QR-Kategorie aus, zum Beispiel Link, Text, WLAN, Kontakt, E-Mail oder Karte.',
        categories: ['Link / URL', 'Text', 'WiFi', 'Kontakt', 'Gmail', 'Google Maps'],
        step2: 'Fügen Sie danach Ihre Daten in das entsprechende Eingabefeld ein.',
        step3Intro: 'Klicken Sie auf Generate & Customize, um das Anpassungsfenster zu öffnen. Dort finden Sie folgende Optionen:',
        options: [
          {
            title: 'Stil & Form:',
            text: 'Passen Sie die Form der Module an, z. B. rund, punktförmig, horizontal, vertikal und weitere Varianten.',
          },
          {
            title: 'Farbe:',
            text: 'Wählen Sie Vorder- und Hintergrundfarben. Zusätzlich sind lineare und radiale Verläufe mit frei wählbaren Winkeln möglich.',
          },
          {
            title: 'Rahmen:',
            text: 'Wählen Sie einen Rahmen aus der Bibliothek, der automatisch passend angewendet wird.',
          },
          {
            title: 'Logo:',
            text: 'Fügen Sie ein Logo in der Mitte ein, entweder aus der Bibliothek oder als eigener Upload.',
          },
          {
            title: 'Vorlagen:',
            text: 'Verwenden Sie fertige Templates, um schnell ein stimmiges Design zu erhalten.',
          },
          {
            title: 'Dateiformat:',
            text: 'Wählen Sie das Download-Format wie PNG, WEBP, SVG oder PDF.',
          },
          {
            title: 'QR-Daten bearbeiten:',
            text: 'Ändern Sie den Inhalt des QR-Codes, ohne Ihre Design-Einstellungen zu verlieren.',
          },
        ],
        finalStep: 'Zum Schluss klicken Sie auf Download. Der QR-Code wird sofort im gewählten Format und mit Ihren Einstellungen gespeichert.',
      },
      card4: {
        title: '4. Vorteile:',
        intro: 'QR-Codes verbinden die physische mit der digitalen Welt. Ein kurzer Scan reicht, um Links, Kontakte oder Standorte sofort zu öffnen.',
        benefits: [
          {
            title: 'Langfristige Nutzung:',
            text: 'QR-Codes haben keine feste Ablaufzeit und bleiben nutzbar, solange die hinterlegten Daten verfügbar sind.',
          },
          {
            title: 'Offline-Scan möglich:',
            text: 'Das Gerät kann das QR-Muster auch ohne Internet lesen und die enthaltenen Daten anzeigen.',
          },
          {
            title: 'Kostenfrei:',
            text: 'Die Erstellung grundlegender QR-Codes ist dauerhaft kostenlos.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'QR-Code Scanner — QR-Codes mit Kamera oder Bild scannen | photremium.com',
      desc: 'QR-Codes sofort mit der Kamera scannen oder ein Bild hochladen. Schnell, privat und sicher.',
      keywords: 'qr-code scanner, qr-code scannen, qr-leser',
    },
    title: 'QR-Code Scanner',
    desc: 'QR-Codes sofort mit der Kamera scannen oder ein Bild hochladen. Schnell, privat & sicher.',
    generateQrCode: 'QR-Code generieren',
    scan: 'Scannen',
    cameraScanner: 'Kamera-Scanner',
    uploadImage: 'Bild hochladen',
    pointCamera: 'Kamera auf einen QR-Code richten',
    startCamera: 'Kamera starten',
    loading: 'Wird geladen…',
    dropQrImage: 'QR-Code-Bild hier ablegen',
    toScan: 'zum Scannen',
    supportedFormats: 'Unterstützt JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Strg+V zum Einfügen',
    scanFromGallery: 'Aus Galerie scannen',
    instantScanning: 'Sofortscanning',
    instantScanningDesc: 'Echtzeit-QR-Code-Erkennung von Kamera oder hochgeladenen Bildern',
    private100: '100% Privat',
    private100Desc: 'Alle Verarbeitung erfolgt in Ihrem Browser. Nichts wird hochgeladen',
    multiFormat: 'Multi-Format',
    multiFormatDesc: 'URLs, Text, WLAN, Kontakte, E-Mail, Telefon & mehr erkennen',
    accessingCamera: 'Kamerazugriff wird hergestellt…',
    cameraDenied: 'Kamerazugriff verweigert. Bitte Kameraberechtigung erlauben und erneut versuchen.',
    noCamera: 'Kein Kamera auf diesem Gerät gefunden.',
    cameraError: 'Kein Zugriff auf Kamera möglich. Bitte erneut versuchen.',
    videoError: 'Videowiedergabe konnte nicht gestartet werden.',
    switchError: 'Kamera konnte nicht gewechselt werden.',
    tryAgain: 'Erneut versuchen',
    switchCamera: 'Kamera wechseln',
    stop: 'Stopp',
    noQrFound: 'Kein QR-Code gefunden',
    couldNotRead: 'Bild konnte nicht gelesen werden',
    scannerFailed: 'Scanner konnte nicht geladen werden',
    noQrFoundDesc: 'Im Bild wurde kein QR-Code erkannt. Bitte ein anderes Bild versuchen oder den Kamera-Scanner verwenden.',
    qrScanned: 'QR-Code gescannt!',
    openLink: 'Link öffnen',
    copied: 'Kopiert!',
    copy: 'Kopieren',
    share: 'Teilen',
    scanAgain: 'Erneut scannen',
    network: 'Netzwerk',
    password: 'Passwort',
    security: 'Sicherheit',
    unknown: 'Unbekannt',
    typeText: 'Text',
    typeUrl: 'URL',
    typeWifi: 'WLAN-Netzwerk',
    typeContact: 'Kontaktkarte',
    typeEmail: 'E-Mail',
    typePhone: 'Telefonnummer',
    typeSms: 'SMS',
    typeLocation: 'Standort',
    blog: {
      tocTitle: 'Inhalt',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Warum einen QR-Code-Scanner verwenden?',
          paragraphs: [
            'Ein QR-Code-Scanner ist im Grunde eine mobile Kamera, die die im QR-Code gespeicherten Informationen dekodiert. Sie müssen die Kamera nur auf den QR-Code richten; unabhängig von der Ausrichtung liest er die spezifischen Muster, erkennt Fehler, korrigiert Fehler bei Bedarf und zeigt die enthaltenen Informationen an.',
          ],
          listTitle: 'Arten von QR-Code-Scannern:',
          bullets: [
            'Webbasierter QR-Code-Scanner: Sie können QR-Codes mit Online-Scannern scannen, die Ihr Browser unterstützt. Sie können auf Informationen über die Kamera oder über das Hochladen eines Bildes zugreifen. Für automatische Weiterleitung und weitere erweiterte Funktionen können Sie https://photremium.com besuchen.',
            'Mobile Kameras: Einige moderne Mobiltelefone haben einen eingebauten QR-Code-Scanner in der Standard-Kamera-App. Diese können Informationen allein durch das Scannen des QR-Codes mit der Kamera abrufen und dekodieren.',
            'Apps: Es gibt einige Apps, die speziell zum Scannen von QR-Codes entwickelt wurden. Für erweiterte Weiterleitung und viele weitere Funktionen können Sie jedoch die App über diesen Link kostenlos installieren: https://photremium.com.',
            'Hardware-Geräte: Es gibt auch Hardware-Geräte zum Scannen von QR-Codes. Diese Geräte werden in großen Einkaufszentren häufig zur Abrechnung von Artikeln eingesetzt.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Warum unseren QR-Code-Scanner wählen?',
          paragraphs: [
            'Sie können mehrere erweiterte Funktionen nutzen, von Weiterleitung bis zum Kopieren des aus dem QR-Code dekodierten Inhalts. In unserem QR-Code-Scanner können Sie viele weitere interessante Funktionen entdecken, wie zum Beispiel:',
          ],
          bullets: [
            'Hohe Geschwindigkeit: Unser QR-Code-Scanner macht die Dekodierung extrem schnell. Sie müssen nur den QR-Code scannen, und unser Tool liefert die Informationen sofort mit erweiterten Optionen zum Kopieren von Text/Link, Öffnen bei erkanntem Link oder automatischem Speichern bei erkanntem Kontakt.',
            'Keine Installation erforderlich: Sie müssen keine separate App installieren, um unseren QR-Code-Scanner zu nutzen. Sie können dieses Tool kostenlos über Ihren lokalen Browser verwenden.',
            'Plattformübergreifender Zugriff: Sie können es auf jedem Gerät verwenden. Keine Sorge wegen Betriebssystemversion oder anderen Anforderungen. Es wird auf allen Versionen und allen Geräten unterstützt.',
            'Alle Formate unterstützt: Alle Datenformate, die in einem QR-Code gespeichert werden können, einschließlich Klartext, WiFi, URLs, Kontakte, Gmail und Google Maps usw., werden von unserem Tool unterstützt.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Schritt-für-Schritt-Anleitung:',
          steps: [
            {
              heading: '1. Wählen Sie zunächst eine Methode zum Scannen des QR-Codes. Es gibt folgende zwei Methoden:',
              subSteps: [
                {
                  heading: 'i. Kamera-Methode',
                  paragraphs: [
                    'Sie können den QR-Code mit der Kamera Ihres Geräts scannen, auch wenn Sie ein Laptop, einen PC oder ein anderes Gerät mit einfacher Kamera verwenden. Ein Klick auf die Schaltfläche „Kamera starten“ zeigt eine Berechtigungsanfrage; erlauben Sie dieser Website den Kamerazugriff für den QR-Scan. Wenn Sie versehentlich abgelehnt haben oder keine Anfrage erscheint, können Sie den Kamerazugriff manuell mit diesen Schritten freigeben:',
                  ],
                  notes: [
                    '➔ Für Chrome (Android / Desktop):',
                    '1. Klicken Sie auf die drei Punkte',
                    '2. Gehen Sie zu Einstellungen',
                    '3. (Diesen Schritt auf Android überspringen) Datenschutz und Sicherheit',
                    '4. Klicken Sie auf Website-Einstellungen',
                    '5. Klicken Sie dann im Bereich Berechtigungen auf Kamera',
                    '6. Suchen Sie die URL unserer Seite: https://photremium.com/qr-code-scanner',
                    '7. Erlauben Sie die Kamera im Dropdown-Menü.',
                    '➔ Für Safari (iPhone / iOS):',
                    '1. Tippen Sie auf das AA-Symbol oder Website-Einstellungen in der Adressleiste.',
                    '2. Wählen Sie Website-Einstellungen.',
                    '3. Tippen Sie auf Kamera und wählen Sie Erlauben.',
                    '4. Wenn es weiterhin blockiert ist: Gehen Sie zu iPhone-Einstellungen > Safari > Kamera und setzen Sie es auf Fragen oder Erlauben.',
                  ],
                },
                {
                  heading: 'ii. Galerie-Methode',
                  paragraphs: [
                    'Sie können ein Bild eines QR-Codes hochladen, um auf die Informationen zuzugreifen. Klicken Sie auf die Schaltfläche „Aus Galerie scannen“, dann öffnet sich der Dateiexplorer. Wählen Sie anschließend das QR-Code-Bild aus. Alle Bildformate werden unterstützt, z. B. .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz und .xbm usw.',
                  ],
                },
              ],
            },
            {
              heading: '2. Wenn Sie den QR-Code auswählen, werden alle Informationen angezeigt; Sie können sie kopieren, teilen oder den Link öffnen, falls erkannt. Wenn Sie möchten, können Sie auch erneut scannen.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Vorteile des QR-Code-Scanners:.',
          paragraphs: [
            'Der QR-Code-Scanner bietet in dieser digitalen Welt mehrere Vorteile. Er macht Zahlungen, Verifizierungen und den Zugriff auf Informationen einfach und schnell – sogar im Offline-Modus.',
          ],
          bullets: [
            'Sofortiger Zugriff auf Informationen: Das Scannen des QR-Codes liefert Informationen in Millisekunden. Er dekodiert Muster, erkennt Fehler und behebt sie sehr schnell – für eine extrem schnelle Nutzererfahrung.',
            'Nahtlose Kommunikation: In dieser fortschrittlichen Zeit besteht ein großer Bedarf an schneller und sicherer Kommunikation für kleine Informationen wie Bankdaten und Produktdetails usw. QR-Code-Scanner lösen dieses Problem, da Zahlungen durch Scannen eines QR-Codes erfolgen. Außerdem verifiziert Google Mobiltelefone per QR, wenn man ein neues Konto am Laptop erstellt.',
            'E-Tickets: An Busbahnhöfen, Bahnhöfen oder Flughäfen können Sie Ihre Tickets einfach verifizieren, ohne lange in der Warteschlange zu stehen. Zudem sind an Flughäfen an mehreren Stellen QR-Scanner installiert, um Warteschlangen zu vermeiden. Das reduziert auch den Personalbedarf und spart automatisch Budget der Fluggesellschaft.',
            'Produktauthentifizierung: Fortschrittliche Premium-Marken bringen einen QR-Code auf ihrem Produkt an. Kunden können diesen QR-Code scannen, um die Echtheit des Produkts zu prüfen – ob es original ist oder nicht.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Gesicht unscharf machen — Gesichter in Bildern online verbergen | photremium.com',
      uploadDesc: 'Gesichter in Bildern automatisch mit KI-Gesichtserkennung unscharf machen. Kostenlos, schnell & privat.',
      uploadKeywords: 'gesicht unscharf machen, gesichter verbergen, gesichtserkennung',
      workspaceTitle: 'Gesicht unscharf machen — photremium.com',
      workspaceDesc: 'Gesichter in Bildern automatisch unscharf machen. 100% kostenlos, schnell & privat.',
      workspaceKeywords: 'gesicht unscharf machen',
    },
    title: 'Gesicht unscharf machen',
    desc: 'Gesichter in Bildern automatisch für mehr Datenschutz erkennen und unscharf machen.',
    toBlurFaces: 'Gesichter unscharf machen',
    autoDetection: 'Automatische Erkennung',
    autoDetectionDesc: 'KI-gestützte Gesichtserkennung findet alle Gesichter sofort',
    customBlur: 'Benutzerdefinierte Unschärfe',
    customBlurDesc: 'Unschärfeintensität, Form und Stil anpassen',
    private100: '100% Privat',
    private100Desc: 'Alle Verarbeitung erfolgt lokal in Ihrem Browser',
    blurTools: 'Unschärfe-Werkzeuge',
    faces: 'Gesichter',
    faceDetection: 'Gesichtserkennung',
    detecting: 'Wird erkannt...',
    autoDetectFaces: 'Gesichter automatisch erkennen',
    exitManualMode: 'Manuellen Modus verlassen',
    manualSelect: 'Manuell auswählen',
    nFaceRegions: '{n} Gesichtsbereich(e) gefunden',
    noFacesDetected: 'Keine Gesichter erkannt — manuellen Modus verwenden',
    manualHint: 'Auf das Bild klicken und ziehen, um ein Rechteck über den zu unscharf machenden Bereich zu zeichnen.',
    blurType: 'Unschärfe-Typ',
    blur: 'Unschärfe',
    emoji: 'Emoji',
    blurIntensity: 'Unschärfestärke',
    strength: 'Stärke',
    blurShape: 'Unschärfeform',
    rectangle: 'Rechteck',
    ellipse: 'Kreis',
    circle: 'Kreis',
    chooseEmoji: 'Emoji auswählen',
    blurRegionsN: 'Unschärfebereiche ({n})',
    faceN: 'Gesicht {n}',
    manualRegionN: 'Manueller Bereich {n}',
    manualN: 'Manuell {n}',
    clearAllRegions: 'Alle Bereiche löschen',
    processingDots: 'Wird verarbeitet...',
    downloadBlurred: 'Unscharfes Bild herunterladen',
    downloadNImages: '{n} Bilder herunterladen',
    downloadDialogTitle: 'Nicht alle Bilder bearbeitet',
    downloadDialogText: 'Sie haben {edited} von {total} Bildern bearbeitet.',
    downloadAll: 'Alle herunterladen',
    removeRegion: 'Bereich entfernen',
    region: 'Bereich',
    notAllEdited: 'Nicht alle Bilder bearbeitet',
    editedXofY: 'Sie haben {edited} von {total} Bildern bearbeitet.',
    nextImage: 'Nächstes Bild',
  },

  faqData: {
    imageConverter: [
      { q: 'Welche Bildformate werden für die Konvertierung unterstützt?', a: 'Wir unterstützen JPG, PNG, WEBP, SVG, GIF, BMP, ICO und TIFF. Sie können zwischen diesen Formaten sofort in Ihrem Browser konvertieren.' },
      { q: 'Wird die Bildqualität bei der Konvertierung beeinträchtigt?', a: 'Bei verlustfreien Formaten wie PNG bleibt die Qualität vollständig erhalten. Bei verlustbehafteten Formaten wie JPG und WEBP verwenden wir optimierte Kodierungseinstellungen.' },
      { q: 'Gibt es eine Dateigrößen- oder Mengenbeschränkung?', a: 'Es gibt keine strenge Begrenzung. Sie können mehrere Bilder auf einmal hochladen und im Stapel konvertieren. Da alles lokal in Ihrem Browser läuft, hängt die Geschwindigkeit von Ihrem Gerät ab.' },
      { q: 'Sind meine Daten sicher? Werden Bilder auf einen Server hochgeladen?', a: 'Absolut. Die gesamte Verarbeitung erfolgt zu 100 % in Ihrem Browser. Ihre Bilder verlassen Ihr Gerät nie.' },
      { q: 'Kann ich transparente PNG-Bilder in JPG konvertieren?', a: 'Ja. Da JPG keine Transparenz unterstützt, werden transparente Bereiche standardmäßig mit einem weißen Hintergrund gefüllt.' },
    ],
    imageCompressor: [
      { q: 'Verringert das Komprimieren eines Bildes die Qualität?', a: 'Nein, das Komprimieren eines Bildes beeinträchtigt die Qualität nicht, solange Sie in den empfohlenen Bereichen bleiben. Qualitätsindikatoren helfen dabei: i. 1 bis 40 % Komprimierung: grüner Hinweis mit „Gute Qualität“. ii. 41 bis 60 % Komprimierung: gelber Hinweis mit „Normale Qualität“. Dieser Bereich ist für gute Ergebnisse empfohlen. iii. 61 bis 100 % Komprimierung: rote Warnung mit „Schlechte Qualität“. In diesem Bereich kann der Qualitätsverlust deutlich sichtbar werden.' },
      { q: 'Welche Bildformate werden für die Komprimierung unterstützt?', a: 'Unser Bildkompressor unterstützt alle folgenden Formate:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Kann ich mehrere Bilder gleichzeitig komprimieren?', a: 'Ja, absolut. Sie können mehrere Bilder (sogar 100+) gleichzeitig komprimieren, wenn Ihr Gerät es unterstützt. Da die Komprimierung Systemressourcen nutzt, funktionieren große Mengen besser auf leistungsstarken Geräten. Bei schwächeren Geräten können Sie in mehreren Durchgängen komprimieren – das Tool bleibt dennoch kostenlos und unbegrenzt nutzbar.' },
      { q: 'Speichern oder laden Sie unsere Bilder auf Ihre Server hoch?', a: 'Nein. Wir laden Ihre Bilder niemals auf unsere Server hoch und speichern sie dort auch nicht. Alles wird lokal in Ihrem Browser komprimiert. Ihre Bilder verlassen Ihr Gerät nicht.' },
      { q: 'Ist dieses Bildkomprimierungs-Tool kostenlos?', a: 'Ja. Unser Bildkompressor ist dauerhaft komplett kostenlos. Es gibt keine Zahlungen, keine versteckten Gebühren und alle Funktionen – einschließlich Mehrfachkomprimierung – sind gratis.' },
    ],
    cropImage: [
      { q: 'Wird durch das Zuschneiden die Bildqualität verringert?', a: 'Nein, das Zuschneiden des Bildes wird die visuelle Qualität des Bildes überhaupt nicht beeinträchtigen. Beim Zuschneiden werden nur die unerwünschten Teile verworfen. Es verändert niemals die Pixel des Teils des Bildes, der zugeschnitten werden soll. Daher können Sie Ihre Bilder in ihrer Originalqualität ohne jegliche Pixelbeschädigung zuschneiden.' },
      { q: 'Welche Bildformate werden für den Bild-Zuschneider unterstützt?', a: 'Sie können ein Bild in jedem beliebigen Format auswählen, da unser Bild-Zuschneider-Tool fast alle Bildformate unterstützt. Diese sind unten aufgeführt:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Werden meine Bilder auf Ihren Server hochgeladen?', a: 'Nein, die gesamte Verarbeitung erfolgt in Ihrem lokalen Browser. Ihre Bilder werden niemals auf unseren Server hochgeladen, da sie Ihr Gerät niemals verlassen. Daher können Sie Ihre persönlichen Bilder mit unserem Bild-Zuschneider ohne Risiko zuschneiden.' },
      { q: 'Kann ich mehrere Bilder gleichzeitig zuschneiden?', a: 'Ja, Sie können mehrere Bilder (sogar 100+) gleichzeitig zuschneiden, wenn Ihr System dies unterstützt. Da das Zuschneiden von Bildern Ihre Systemressourcen nutzt, können Sie mit einem leistungsstarken Laptop, PC oder Mobilgerät viele Bilder gleichzeitig zuschneiden. Wenn Sie ein Gerät mit niedriger Leistung haben, können Sie Bilder in Chargen zuschneiden, da dieses Tool kostenlos ist, auch wenn Sie mehrere Bilder gleichzeitig zuschneiden.' },
      { q: 'Ist dieses Bild-Zuschneider-Tool kostenlos nutzbar?', a: 'Ja, dieses Bild-Zuschneider-Tool ist für immer völlig kostenlos nutzbar. Sie können dieses Tool überall, jederzeit und auf jedem Gerät verwenden. Sie erhalten nicht nur ein responsives Design für alle Geräte, sondern werden auch niemals aufgefordert, für eine Premium-Funktion zu zahlen. Alle Funktionen sind vollständig kostenlos ohne versteckte Gebühren.' },
    ],
    resizeImage: [
      { q: 'Kann ich mehrere Bilder gleichzeitig skalieren?', a: 'Absolut, unser Bild-Resizer erlaubt das Skalieren mehrerer Bilder auf einmal. Laden Sie einfach so viele Bilder hoch, wie Ihr Gerät unterstützt, und unsere KI-Engine skaliert alle Bilder in einem Durchgang. Wenn Ihr Gerät leistungsschwächer ist, skalieren Sie in mehreren Chargen, um Verzögerungen zu vermeiden. Das Skalieren nutzt Geräte-Ressourcen, damit keine Server-Uploads nötig sind und Ihre Privatsphäre geschützt bleibt.' },
      { q: 'Ist dieses Bild-Skalierungs-Tool kostenlos nutzbar?', a: 'Ja, dieses Tool ist dauerhaft kostenlos nutzbar. Sie werden nie nach einem kostenpflichtigen Abo gefragt, um Premium-Funktionen freizuschalten. Beim Download Ihrer skalierten Bilder fallen keine versteckten Gebühren an.' },
      { q: 'Verringert das Skalieren die Bildqualität?', a: '✅Decrease Size (downscale): Das Verkleinern eines Bildes reduziert die visuelle Qualität nicht. Im Gegenteil, das skalierte Bild wirkt oft sogar schärfer als das Original. Daher führt das Verkleinern auf kleinere Maße nicht zu Qualitätsverlust.\n❌Increase Size (upscale): Das Vergrößern über die Originalgröße kann die visuelle Qualität beeinflussen. Wie stark, hängt vom Ausmaß der Vergrößerung ab. Je stärker Sie vergrößern, desto stärker sinkt die Qualität.' },
      { q: 'Ist dieses Bild-Skalierungs-Tool sicher?', a: 'Ja, unser Bild-Resizer ist vollständig sicher, insbesondere für persönliche und private Bilder, da alle Bilder lokal verarbeitet werden. Keine Ihrer Daten verlässt Ihr Gerät in irgendeiner Form während der Verarbeitung. Sie können persönliche Bilder daher risikofrei skalieren.' },
      { q: 'Welche Bildformate werden unterstützt?', a: 'Alle Bildformate werden von unserem Bild-Resizer unterstützt. Sie können Bilder in diesen Formaten auswählen:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Wie funktioniert die Hintergrundentfernung?', a: 'Wir verwenden ein fortschrittliches KI-Modell, das direkt in Ihrem Browser läuft, um das Motiv zu erkennen und vom Hintergrund zu trennen.' },
      { q: 'Funktioniert es bei komplexen Hintergründen?', a: 'Ja. Das KI-Modell verarbeitet eine Vielzahl von Szenen. Die besten Ergebnisse werden bei klarem Kontrast zwischen Motiv und Hintergrund erzielt.' },
      { q: 'Kann ich den Hintergrund von mehreren Bildern auf einmal entfernen?', a: 'Ja. Laden Sie mehrere Bilder hoch und das Tool verarbeitet sie nacheinander. Alle Ergebnisse als ZIP herunterladen.' },
      { q: 'In welchem Format wird die Ausgabe gespeichert?', a: 'Die Ausgabe ist immer eine PNG-Datei mit transparentem Hintergrund.' },
      { q: 'Werden meine Bilder an einen Server gesendet?', a: 'Nein. Das KI-Modell läuft vollständig in Ihrem Browser mit WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. Ist das Photremium-Wasserzeichen-Tool komplett kostenlos?', a: 'Ja, das Wasserzeichen-Tool unter photremium.com/watermark-image ist vollständig kostenlos, ohne Konto und ohne Abo. Sie können einzelne Bilder oder ganze Stapel ohne Paywall, ohne erzwungene Registrierung und ohne Download-Limits markieren. Das Tool wird dadurch getragen, dass Photremium insgesamt nützlich ist — nicht durch das Sperren von Kernfunktionen.' },
      { q: '2. Wie viele Bilder kann ich gleichzeitig wasserzeichnen?', a: 'Das Tool unterstützt Batch-Wasserzeichen für viele Bilder. Sie können einen ganzen Ordner per Drag-and-Drop hochladen oder mit Ctrl+Click dutzende Dateien auswählen. Die linke Vorschauleiste zeigt alle Dateien, und mit "Watermark & Download All" rendert das Tool jedes Bild und packt es in ein ZIP (oder lädt sie als separate Dateien herunter — je nach Auswahl). In der Praxis ist das Limit der verfügbare Arbeitsspeicher Ihres Geräts, nicht eine künstliche Begrenzung.' },
      { q: '3. Welche Formate werden für Ein- und Ausgabe unterstützt?', a: 'Als Eingabe werden alle Formate unterstützt, die die File API Ihres Browsers verarbeiten kann — typischerweise JPEG, JPG, PNG, WEBP, GIF (statisch), BMP und SVG. Als Ausgabe bleibt das Format erhalten: PNG bleibt PNG, JPEG bleibt JPEG (mit Qualität 0.95). So wird verhindert, dass ein verlustfreies PNG versehentlich in ein verlustbehaftetes JPG konvertiert wird.' },
      { q: '4. Sieht das Wasserzeichen bei unterschiedlichen Auflösungen gleich aus?', a: 'Ja, dank der proportionalen Repositionierung. Bei Bildern mit verschiedenen Abmessungen wird das Wasserzeichen auf dem Referenzbild erstellt. Beim Export berechnet die Engine die Position jedes Layers als relative Abweichung vom Bildzentrum und wendet dieselbe Proportion auf jedes Zielbild an. Die Größe wird proportional skaliert (basierend auf dem kleineren Verhältnis aus Breite oder Höhe), sodass der Layer nicht über den Rand hinausgeht. Ergebnis: gleichbleibende relative Position und Größe in der gesamten Serie.' },
      { q: '5. Kann ich mein eigenes Logo oder eine Signatur als Wasserzeichen verwenden?', a: 'Absolut. Mit "Add Image" im rechten Panel können Sie eine Bilddatei als Wasserzeichen-Layer hochladen. PNGs mit Transparenz sind ideal — die Transparenz bleibt erhalten, sodass nur das Logo sichtbar ist. Sie können das Logo über Eckgriffe skalieren (Seitenverhältnis bleibt erhalten), drehen, spiegeln, die Deckkraft ändern und sogar Rahmen oder abgerundete Ecken hinzufügen. Viele Nutzer halten eine transparente Logo-Datei speziell fürs Wasserzeichen bereit.' },
      { q: '6. Wie mache ich das Wasserzeichen transparent oder halbtransparent?', a: 'Wählen Sie den Wasserzeichen-Layer auf der Leinwand. In der oberen Toolbar finden Sie den Deckkraftregler mit Prozentwert — Sie können tippen oder ziehen. Für ein dezentes, professionelles Wasserzeichen sind 30–50% üblich; für ein deutliches Copyright 70–80%. Zum schnellen Vergleich können Sie die Sichtbarkeit im Layer-Manager (Augen-Symbol) ein- und ausschalten.' },
      { q: '7. Kann ich mehrere Wasserzeichen auf einem Bild verwenden?', a: 'Ja — das Layer-System unterstützt unbegrenzt viele Wasserzeichen, jeweils unabhängig konfigurierbar. Sie können gleichzeitig einen Text-Hinweis unten rechts, ein Logo oben links und ein gekacheltes "SAMPLE" verwenden. Jeder Layer hat eigene Deckkraft, Rotation, Position, Größe und Stil. Der Layer-Manager organisiert alles und erlaubt das Ein-/Ausblenden ohne Löschen, damit Sie Varianten testen können.' },
      { q: '8. Was macht die Kachel-Funktion und wann sollte ich sie nutzen?', a: 'Kacheln wiederholt Ihr Wasserzeichen in einem Raster über das gesamte Bild. Grid 2×2 erzeugt vier Kopien, Grid 3×3 neun Kopien. Der Abstand-Regler steuert die Lücken. Kacheln ist ideal, wenn Sie das Bild unbrauchbar für unautorisierte Nutzung machen möchten — ein einzelnes Wasserzeichen in der Ecke lässt sich oft wegschneiden, ein flächiges Muster hingegen kaum, ohne das Bild zu zerstören. Das ist typisch für Vertragsvorschauen, Entwürfe oder Inhalte vor der Bezahlung.' },
      { q: '9. Funktioniert das Tool auf Smartphones und Tablets?', a: 'Ja, das Tool ist vollständig responsiv und für Mobilgeräte optimiert. Unter 900px wird die Drei-Panel-Ansicht gestapelt: Die Miniaturen werden zu einer horizontalen Leiste, die Leinwand bleibt im Zentrum, und die Einstellungen erscheinen als Bottom-Sheet über einen schwebenden Zahnrad-Button. Alle Interaktionen — Ziehen, Skalieren, Drehen — sind touchfähig. Die Griffe sind auf Mobilgeräten größer (16×16 px) für bessere Bedienbarkeit.' },
      { q: '10. Sind meine Bilddaten privat? Werden Fotos auf Server hochgeladen?', a: 'Ihre Bilder verlassen Ihr Gerät nicht. Der gesamte Workflow — Laden, Rendern, Exportieren — läuft im Browser mit JavaScript und der HTML5 Canvas API. Die File API lädt das Bild in den Speicher, der Wasserzeichen-Layer wird auf eine Offscreen-Canvas gezeichnet, und beim Download werden die Pixel in einen Blob umgewandelt, der lokal gespeichert wird. Es gibt keine Netzwerkanfragen mit Bilddaten. Zusätzlich schützt eine Seiten-Verlasser-Abfrage davor, dass Sie eine aktive Session versehentlich verlieren.' },
    ],
    qrCodeGenerator: [
      { q: 'Läuft dieser QR-Code irgendwann ab?', a: 'Nein, diese QR-Codes laufen nicht ab und bieten lebenslange Nutzung. Da sie fest codierte Anweisungen in Form von Bits in quadratischen Modulen speichern, können die darin gespeicherten Informationen nicht geändert oder entfernt werden. Sie können die Informationen auch nach Jahren noch mit jeder Kamera durch einfaches Scannen abrufen.' },
      { q: 'Warum lässt sich mein QR-Code nicht scannen?', a: 'Ihr QR-Code kann aus folgenden Gründen nicht scanbar sein: i. Geringer Kontrast: Wenn Vordergrund- und Hintergrundfarbe zu ähnlich sind, leidet die Sichtbarkeit und das Scannen kann fehlschlagen. Unser Tool warnt Sie während der Anpassung bei niedrigem Kontrast und ähnlichen Problemen. ii. Zu viele Daten: Wenn Sie sehr viel Text codieren, wird der QR-Code sehr komplex und schwer lesbar. Ein Textlängen-Hinweis hilft Ihnen bei der optimalen Länge. iii. Unscharfer Druck: Laden Sie den QR-Code in hoher Auflösung herunter, z. B. als PNG oder SVG, was von unserem Tool unterstützt wird.' },
      { q: 'Kann ich ein Logo in den QR-Code einfügen?', a: 'Ja, natürlich. Sie können ein eigenes Logo hochladen oder eines aus der integrierten Logo-Bibliothek auswählen. Das gewählte Logo wird automatisch in der Mitte des QR-Codes platziert und angepasst.' },
      { q: 'Wie kann ich den QR-Code scannen?', a: 'Sie können den QR-Code direkt mit der Kamera Ihres Smartphones scannen. Für automatische Link-Weiterleitung und weitere erweiterte Funktionen können Sie außerdem kostenlos unseren QR-Code-Scanner unter https://photremium.com/qr-code-scanner verwenden.' },
      { q: 'Wie viele QR-Codes kann ich kostenlos erstellen?', a: 'UNBEGRENZT! Sie können beliebig viele QR-Codes kostenlos erstellen. Alle Funktionen, Anpassungen und Vorlagen sind dauerhaft kostenlos. Sie brauchen kein Abo, um Premium-Funktionen zu nutzen.' },
      { q: 'Muss ich mich anmelden/registrieren, um einen QR-Code zu erstellen?', a: 'Nein. Geben Sie einfach Ihren Inhalt ein, erstellen Sie den QR-Code und laden Sie ihn nach der Anpassung herunter. Eine Anmeldung oder Registrierung ist nicht erforderlich, da alle Funktionen vollständig kostenlos zugänglich sind.' },
    ],
    qrCodeScanner: [
      { q: 'Kann ich QR-Codes aus gespeicherten Bildern und Screenshots scannen?', a: '**Ja**, Sie können einen QR-Code aus gespeicherten Bildern oder Screenshots scannen. Unser QR-Code-Scanner https://photremium.com/qr-code-scanner ermöglicht Ihnen das Scannen aus der Galerie. Sie müssen nur das Bild auswählen, und Sie erhalten alle aus diesem QR-Code dekodierten Informationen.' },
      { q: 'Muss ich eine App installieren, um den QR-Code-Scanner zu nutzen?', a: '**Nein**, unser webbasierter QR-Code-Scanner ermöglicht das Scannen ohne App-Installation. Sie können unseren erweiterten QR-Code-Scanner auf jedem Gerät kostenlos verwenden.' },
      { q: 'Warum erkennt der Scanner den QR-Code nicht?', a: 'Ihr QR-Code wird aus einem der folgenden Gründe nicht gescannt: i. Unzureichendes Licht: Das Scannen bei schwachem Licht kann Probleme verursachen. Schalten Sie die Taschenlampe ein und erhöhen Sie die Helligkeit, wenn Sie von einem Bildschirm scannen. ii. Entfernung: Das Scannen aus ungeeigneter Entfernung verursacht ebenfalls Probleme. Die optimale Entfernung zum Scannen eines QR-Codes beträgt etwa 10 Zoll (25 cm). iii. Verschmutzte Kameralinsen: Ein QR-Code kann auch wegen verschmutzter Linsen nicht gescannt werden. Reinigen Sie die Linsen vor dem Scannen. „Sehen Sie ein Box-Raster im Scanner? Platzieren Sie den QR-Code einfach darin, um ihn erfolgreich zu scannen.“' },
      { q: 'Kann dieses Tool einen invertierten oder farbigen QR-Code scannen?', a: '**Ja**, Sie können QR-Codes in jeder Farbe oder Ausrichtung scannen. Wenn jedoch der Kontrast zwischen Hintergrund- und Vordergrundfarbe zu gering ist, kann das Scannen erschwert werden.' },
      { q: 'Ist dieses Tool kostenlos?', a: '**Ja**, dieses Tool ist vollständig kostenlos. Sie können unbegrenzt QR-Codes dauerhaft kostenlos scannen.' },
    ],
    faceBlur: [
      { q: 'Wie funktioniert die Gesichtserkennung?', a: 'Wir verwenden ein KI-gestütztes Gesichtserkennungsmodell, das direkt in Ihrem Browser läuft. Es identifiziert Gesichter im Bild.' },
      { q: 'Kann ich auswählen, welche Gesichter weichgezeichnet werden?', a: 'Ja. Nach der Erkennung wird jede Gesichtsregion hervorgehoben und Sie können auswählen, welche weichgezeichnet werden sollen.' },
      { q: 'Welche Weichzeichenstile sind verfügbar?', a: 'Sie können zwischen Gaußscher Unschärfe, Pixelierung oder einfarbiger Füllung wählen, jeweils mit vollständig einstellbarer Intensität.' },
      { q: 'Kann ich Gesichter in mehreren Bildern auf einmal weichzeichnen?', a: 'Ja. Laden Sie mehrere Bilder hoch, konfigurieren Sie die Unschärfebereiche und laden Sie alle verarbeiteten Bilder herunter.' },
      { q: 'Werden meine Fotos an einen entfernten Server gesendet?', a: 'Nein. Das KI-Modell läuft in Ihrem Browser mit WebAssembly. Ihre Fotos werden nie hochgeladen.' },
    ],
    photoEditor: [
      { q: 'Welche Bearbeitungsfunktionen sind verfügbar?', a: 'Sie können Helligkeit, Kontrast, Sättigung anpassen, Filter anwenden, Text hinzufügen, Überlagerungen, Rahmen, Sticker und vieles mehr — alles im Browser.' },
      { q: 'Kann ich Änderungen rückgängig machen und wiederherstellen?', a: 'Ja. Der Editor unterstützt den vollständigen Rückgängig-/Wiederherstellen-Verlauf.' },
      { q: 'Welche Dateiformate kann ich bearbeiten und exportieren?', a: 'Sie können JPG, PNG, WEBP und andere gängige Formate bearbeiten. Das bearbeitete Bild kann im bevorzugten Format und Qualität exportiert werden.' },
      { q: 'Funktioniert der Editor auf Mobilgeräten?', a: 'Ja. Der Editor ist vollständig responsiv und touchfreundlich.' },
      { q: 'Werden meine Bilder auf Ihren Servern gespeichert?', a: 'Nein. Alle Bearbeitungen werden lokal durchgeführt. Ihre Bilder verlassen Ihr Gerät nie.' },
    ],
  },
};

export default de;
